import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Card, Typography, TextField, Divider, Paper, IconButton, CardContent, LinearProgress, FormControl, Select, MenuItem, Menu, MenuList, List, ListItem, ListItemText } from '@mui/material';
import { Close as CloseIcon, Check as CheckIcon, Add as AddIcon, Edit as EditIcon, Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';
import { Row, Col } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import CommentsImage from '../../assets/Images/CommentsImage.svg';
import MicrosoftRFP from './ExtractRfpDocuments/MicrosoftRFP';
import PDFICON from '../../assets/Images/PDF.svg'
import CircularProgress from '@mui/material/CircularProgress';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import axios from 'axios';
import './Dashboard.css'
import Trash_Empty from '../../assets/Images/Trash_Empty.svg';
import ExtractIMG from '../../assets/Images/extract.svg';
import EYEIMG from '../../assets/Images/eye.svg';
import NotificationsPanel from './Notifications';
import { useSnackbar } from '../SnackbarContext';
import Backdrop from '@mui/material/Backdrop';
import GlobalVariable from "../../services/Global";
import ResponsiveDocument from './ResponsiveDocument';
import Tooltip from '@mui/material/Tooltip';
const baseApiUrl = GlobalVariable.BASE_API_URL;

const style = {
    position: 'absolute',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    borderRadius: 4,
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    width: "90%",
    margin: 10
};

const styled = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 650,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 3,
    borderRadius: 4,
};

function RfpPreview() {
    const location = useLocation();
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { id } = useParams();
    const [open, setOpen] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null)
    const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false)
    const [file, setFile] = useState(null);
    const [progress, setProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [paused, setPaused] = useState(false);
    const [resumeRequested, setResumeRequested] = useState(false);
    const uploadTimer = useRef(null);
    const [documentType, setDocumentType] = useState('')
    const [fileName, setFileName] = useState('');
    const [comment, setComment] = useState()
    const [remark, setRemark] = useState()
    const [rowData, setRowData] = useState({});
    const [Commentcount, setCommentcount] = useState([]);
    const [remarkcount, setRemarkcount] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [documentToDelete, setDocumentToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showMicrosoftRFP, setShowMicrosoftRFP] = useState(true);
    const [isCloseDisabled, setIsCloseDisabled] = useState(false);
    const [docResponse, setDocResponse] = useState('')
    const [isNotificationsOpen, setNotificationsOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [specDocId, setSpecDocId] = useState("");
    const [addDocLoading, setAddDocLoading] = useState(false)
    const [isUploadAvailable, setIsUploadAvailable] = useState(false);
    const[fileUploadedName,setFileUploadedName]=useState("")
    const microsoftRfpRef = useRef(null);
    const [folderPaths, setFolderPaths] = useState([]);
    const [showFolderTree, setShowFolderTree] = useState(false);
    const [addedFiles, setAddedFiles] = useState([]); // Track paths of files added to folders
    const [addedFilesData, setAddedFilesData] = useState(new Map()); // Store file metadata by path
    const [selectedFileUrls, setSelectedFileUrls] = useState(new Set()); // Track selected files from folder structure
    const [uploadMenuAnchor, setUploadMenuAnchor] = useState(null); // For upload menu
    const [isRootFolderMenu, setIsRootFolderMenu] = useState(false); // Track if menu is for root folder
    const [targetFolderPath, setTargetFolderPath] = useState(''); // Track which folder files should be uploaded to
    const [files, setFiles] = useState([]); // For folder uploads
    const [editingFile, setEditingFile] = useState(null); // Track which file is being renamed (file_url)
    const [editingFileName, setEditingFileName] = useState(''); // Track the new file name being edited
    const [confirmUploadModalOpen, setConfirmUploadModalOpen] = useState(false); // Confirmation modal for file/folder upload
    const [pendingUploadFile, setPendingUploadFile] = useState(null); // File waiting for confirmation
    const [pendingUploadFiles, setPendingUploadFiles] = useState([]); // Files waiting for confirmation (for folder upload)
    const [pendingUploadFolderName, setPendingUploadFolderName] = useState(''); // Folder name for confirmation
    const [pendingUploadType, setPendingUploadType] = useState('file'); // 'file' or 'folder'


    const statusMapping = {
        1: 'New',
        4: 'Submitted',
        3: "On Hold",
        2: 'In Progress'
    }

    const storedData = JSON.parse(localStorage.getItem('userDetails'));
    const userName = storedData.userDetails.userName;

    const fetchDocuments = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${baseApiUrl}/dashboard/listdocumnets/get_all_docs`, {
                params: { rfpid: id }
            });

            if (response.status === 200) {
                setDocuments(response.data.results);
            } else {
                console.error("Failed to fetch documents");

            }
        } catch (error) {
            console.error("Error fetching documents:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchrfpData();
    }, []);


    const fetchrfpData = async () => {
        setFetchLoading(true);
        try {
            const response = await axios.get(`${baseApiUrl}/dashboard/fetchrfp?id=${id}`);
            const details = response.data.details;
            
            // Ensure mode is set to 'folder' if we have files
            if (!details.mode && details.allFiles && Array.isArray(details.allFiles) && details.allFiles.length > 0) {
                details.mode = 'folder';
            }
            
            setRowData(details);
            setCommentcount(details.comments);
            setRemarkcount(details.remarks);
            setIsUploadAvailable(details.is_upload_rfp);
            setFileUploadedName(details.file_name);
            
            // Get current documents to filter selectedFiles
            const docsResponse = await axios.get(`${baseApiUrl}/dashboard/listdocumnets/get_all_docs`, {
                params: { rfpid: id }
            });
            
            const existingDocUrls = new Set();
            const existingDocNames = new Set();
            if (docsResponse.data.results && Array.isArray(docsResponse.data.results)) {
                docsResponse.data.results.forEach(doc => {
                    if (doc.doc_url) existingDocUrls.add(doc.doc_url);
                    if (doc.file_url) existingDocUrls.add(doc.file_url);
                    if (doc.doc_name) {
                        const normalize = (name) => {
                            if (!name) return '';
                            return decodeURIComponent(String(name)).toLowerCase().trim().replace(/[^a-z0-9]/g, '');
                        };
                        existingDocNames.add(normalize(doc.doc_name));
                    }
                });
            }
            
            // Filter selectedFiles to only include files that exist in documents
            if (response.data.details.selectedFiles && Array.isArray(response.data.details.selectedFiles)) {
                const filteredSelectedFiles = response.data.details.selectedFiles.filter(url => {
                    // Check if URL exists in documents
                    if (existingDocUrls.has(url)) return true;
                    
                    // Check if file name matches any document name
                    const urlFileName = getFileNameFromUrl(url);
                    const normalize = (name) => {
                        if (!name) return '';
                        return decodeURIComponent(String(name)).toLowerCase().trim().replace(/[^a-z0-9]/g, '');
                    };
                    return existingDocNames.has(normalize(urlFileName));
                });
                
                setSelectedFileUrls(new Set(filteredSelectedFiles));
            } else {
                setSelectedFileUrls(new Set());
            }
            setFetchLoading(false);
        } catch (error) {
            console.error('Error fetching RFP details:', error);
            setFetchLoading(false);
        }
    };

    // Fetch updated folder structure from backend after file upload
    const fetchUpdatedFolderStructure = async (uploadResponse = null) => {
        try {
            // Fetch updated structure from backend - this will include the newly uploaded file
            const response = await axios.get(`${baseApiUrl}/dashboard/fetchrfp?id=${id}`);
            
            if (response.data && response.data.details) {
                const updatedData = response.data.details;
                
                // Update rowData with latest folder structure from backend
                // This ensures the tree shows only what backend has confirmed
                setRowData(prevData => ({
                    ...prevData,
                    allFiles: updatedData.allFiles || prevData.allFiles,
                    structure: updatedData.structure || prevData.structure,
                    selectedFiles: updatedData.selectedFiles || prevData.selectedFiles,
                    mode: updatedData.mode || (updatedData.allFiles && updatedData.allFiles.length > 0 ? 'folder' : prevData.mode),
                    folder_name: updatedData.folder_name || prevData.folder_name
                }));
                
                // Update selected files if available
                if (updatedData.selectedFiles && Array.isArray(updatedData.selectedFiles)) {
                    setSelectedFileUrls(new Set(updatedData.selectedFiles));
                }
                
                // Clear any locally added files - backend is now the source of truth
                setAddedFiles([]);
                setAddedFilesData(new Map());
                
                // Ensure folder tree is visible if we have files
                if (updatedData.allFiles && Array.isArray(updatedData.allFiles) && updatedData.allFiles.length > 0) {
                    setShowFolderTree(true);
                } else if (updatedData.mode === "folder" || (updatedData.structure && (updatedData.structure.files?.length > 0 || updatedData.structure.sub_folders?.length > 0))) {
                    setShowFolderTree(true);
                }
                
                return updatedData;
            }
        } catch (error) {
            // Fallback to regular fetchrfpData if specific endpoint fails
            fetchrfpData();
        }
    };

    // Helper to replace spaces with underscores in file names
    const sanitizeFileName = (fileName) => {
        if (!fileName) return '';
        // Replace spaces with underscores
        return fileName.replace(/\s+/g, '_');
    };

    // Helper to extract filename from URL
    const getFileNameFromUrl = (url) => {
        if (!url) return '';
        const parts = url.split('/');
        return decodeURIComponent(parts[parts.length - 1]);
    };

    // Build tree structure from allFiles URLs
    const buildTreeFromFiles = (allFiles, selectedFiles) => {
        if (!allFiles || !Array.isArray(allFiles) || allFiles.length === 0) {
           
            return null;
        }

        const tree = {};
        const selectedSet = new Set(selectedFiles || []);

        allFiles.forEach(fileUrl => {
            // Extract path from URL
            // Example: "https://documents-rfp.s3.ap-south-1.amazonaws.com/documents/file.pdf"
            // pathname = "/documents/file.pdf"
            let pathParts = [];
            try {
                const urlObj = new URL(fileUrl);
                pathParts = urlObj.pathname.split('/').filter(part => part.length > 0);
            } catch (e) {
                // If URL parsing fails, try to extract path manually
                // Handle relative paths or malformed URLs
                const pathMatch = fileUrl.match(/\/([^?#]+)/);
                if (pathMatch) {
                    pathParts = pathMatch[1].split('/').filter(part => part.length > 0);
                } else {
                    // Fallback: treat entire URL as filename
                    pathParts = [fileUrl.split('/').pop()];
                }
            }
            
            if (pathParts.length === 0) return;

            const fileName = decodeURIComponent(pathParts[pathParts.length - 1]);
            const folderParts = pathParts.slice(0, -1);
            const isSelected = selectedSet.has(fileUrl);

            // Navigate/create folder structure starting from root
            let current = tree;
            folderParts.forEach((folderName) => {
                const decodedFolderName = decodeURIComponent(folderName);
                if (!current[decodedFolderName]) {
                    current[decodedFolderName] = {
                        type: 'folder',
                        folder_name: decodedFolderName,
                        files: [],
                        sub_folders: {}
                    };
                }
                current = current[decodedFolderName].sub_folders;
            });

            // Add file to the appropriate location
            if (folderParts.length === 0) {
                // File at root level
                if (!tree.files) {
                    tree.files = [];
                }
                tree.files.push({
                    file_name: fileName,
                    file_url: fileUrl,
                    is_selected: isSelected
                });
            } else {
                // File in a folder - navigate to the deepest folder
                // We need to navigate through the folder structure correctly
                let currentLevel = tree;
                let foundFolder = null;
                
                for (let i = 0; i < folderParts.length; i++) {
                    const folderName = decodeURIComponent(folderParts[i]);
                    
                    if (i === 0) {
                        // First level - folders are directly in tree
                        if (currentLevel[folderName] && currentLevel[folderName].type === 'folder') {
                            foundFolder = currentLevel[folderName];
                            currentLevel = foundFolder.sub_folders;
                        } else {
                            return; // Skip this file
                        }
                    } else {
                        // Nested levels - folders are in sub_folders
                        if (currentLevel[folderName] && currentLevel[folderName].type === 'folder') {
                            foundFolder = currentLevel[folderName];
                            currentLevel = foundFolder.sub_folders;
                        } else {
                            return; // Skip this file
                        }
                    }
                }
                
                // Add file to the found folder
                if (foundFolder && foundFolder.type === 'folder') {
                    if (!foundFolder.files) {
                        foundFolder.files = [];
                    }
                    foundFolder.files.push({
                        file_name: fileName,
                        file_url: fileUrl,
                        is_selected: isSelected
                    });
                }
            }
        });

        // Convert nested object structure to array format
        const convertToArrayFormat = (node) => {
            if (!node || typeof node !== 'object') {
                return null;
            }
            
            if (node.type === 'folder') {
                const result = {
                    folder_name: node.folder_name || 'Unknown',
                    files: (node.files || []).sort((a, b) => (a.file_name || '').localeCompare(b.file_name || '')),
                    sub_folders: []
                };
                
                // Convert sub_folders object to array
                if (node.sub_folders && typeof node.sub_folders === 'object' && Object.keys(node.sub_folders).length > 0) {
                    result.sub_folders = Object.values(node.sub_folders)
                        .filter(subFolder => subFolder && subFolder.type === 'folder') // Safety check
                        .map(subFolder => convertToArrayFormat(subFolder))
                        .filter(subFolder => subFolder !== null) // Remove null results
                        .sort((a, b) => (a.folder_name || '').localeCompare(b.folder_name || ''));
                }
                return result;
            }
            return null;
        };

        // Determine root folder name
        const rootKeys = Object.keys(tree).filter(key => tree[key] && tree[key].type === 'folder');
        const rootFiles = (tree.files && Array.isArray(tree.files)) ? tree.files : [];
        
        if (rootKeys.length === 1 && rootFiles.length === 0) {
            // Single root folder, no root files
            const rootFolder = tree[rootKeys[0]];
            if (rootFolder) {
                return convertToArrayFormat(rootFolder);
            }
        } else if (rootKeys.length > 0 || rootFiles.length > 0) {
            // Multiple folders or root files - create root structure
            const rootFolderName = rowData?.folder_name || (rootKeys.length === 1 && tree[rootKeys[0]] ? tree[rootKeys[0]].folder_name : 'Root');
            const convertedSubFolders = rootKeys
                .map(key => {
                    const folder = tree[key];
                    return folder ? convertToArrayFormat(folder) : null;
                })
                .filter(folder => folder !== null)
                .sort((a, b) => (a.folder_name || '').localeCompare(b.folder_name || ''));
            
            return {
                folder_name: rootFolderName,
                files: rootFiles
                    .filter(file => file && file.file_name) // Safety check
                    .sort((a, b) => (a.file_name || '').localeCompare(b.file_name || '')),
                sub_folders: convertedSubFolders
            };
        }

        return null;
    };

    // Merge newly added files into folder tree structure
    const mergeAddedFilesIntoTree = (folderTree, addedFiles, addedFilesData) => {
        if (!folderTree || !addedFiles || addedFiles.length === 0) {
            return folderTree;
        }
        
        // Deep clone the tree to avoid mutating the original
        const mergedTree = JSON.parse(JSON.stringify(folderTree));
        
        // Helper to navigate to folder and add file
        const addFileToFolder = (tree, folderPath, fileName) => {
            const pathParts = folderPath.split('/').filter(p => p.length > 0);
            
            // If no folder path, add to root
            if (pathParts.length === 0) {
                if (!tree.files) tree.files = [];
                const exists = tree.files.some(f => f.file_name === fileName);
                if (!exists) {
                    tree.files.push({
                        file_name: fileName,
                        file_url: null,
                        is_selected: false
                    });
                }
                return;
            }
            
            // Navigate through the folder structure
            let current = tree;
            
            // If first part matches root folder name, skip it
            let startIndex = 0;
            if (pathParts[0] === tree.folder_name) {
                startIndex = 1;
            }
            
            // Navigate through sub_folders
            for (let i = startIndex; i < pathParts.length; i++) {
                const folderName = pathParts[i];
                
                if (!current.sub_folders) {
                    current.sub_folders = [];
                }
                
                let found = current.sub_folders.find(sub => sub.folder_name === folderName);
                if (!found) {
                    // Create new subfolder if it doesn't exist
                    found = {
                        folder_name: folderName,
                        files: [],
                        sub_folders: []
                    };
                    current.sub_folders.push(found);
                }
                current = found;
            }
            
            // Add file to the current folder
            if (!current.files) current.files = [];
            const exists = current.files.some(f => f.file_name === fileName);
            if (!exists) {
                current.files.push({
                    file_name: fileName,
                    file_url: null,
                    is_selected: false
                });
            }
        };
        
        // Process each added file
        addedFiles.forEach(filePath => {
            const pathParts = filePath.split('/');
            const fileName = pathParts[pathParts.length - 1];
            const folderPath = pathParts.slice(0, -1).join('/');
            
            addFileToFolder(mergedTree, folderPath, fileName);
        });
        
        // Sort files and folders alphabetically
        const sortTree = (node) => {
            if (node.files) {
                node.files.sort((a, b) => (a.file_name || '').localeCompare(b.file_name || ''));
            }
            if (node.sub_folders) {
                node.sub_folders.sort((a, b) => (a.folder_name || '').localeCompare(b.folder_name || ''));
                node.sub_folders.forEach(sortTree);
            }
        };
        sortTree(mergedTree);
        
        return mergedTree;
    };

    // Check if a file exists anywhere in the entire tree structure
    const checkFileExistsInTree = (tree, fileName) => {
        if (!tree || !fileName) {
            return false;
        }
        
        // Normalize file name for comparison (handle URL encoding, case-insensitive, spaces to underscores)
        const normalizeFileName = (name) => {
            if (!name) return '';
            try {
                // Decode URL encoding, lowercase, trim, and replace spaces with underscores
                let normalized = decodeURIComponent(String(name)).toLowerCase().trim();
                // Replace all spaces (single or multiple) with underscores
                normalized = normalized.replace(/\s+/g, '_');
                return normalized;
            } catch (e) {
                // If decode fails, just lowercase and trim, then replace spaces with underscores
                let normalized = String(name).toLowerCase().trim();
                normalized = normalized.replace(/\s+/g, '_');
                return normalized;
            }
        };
        
        const normalizedTarget = normalizeFileName(fileName);
        
        // Helper to recursively check files in tree
        const checkInNode = (node, path = '') => {
            if (!node) return false;
            
            // Check files in current node
            if (node.files && Array.isArray(node.files)) {
                for (const file of node.files) {
                    if (file && file.file_name) {
                        const normalizedName = normalizeFileName(file.file_name);
                        if (normalizedName === normalizedTarget) {
                            return true;
                        }
                    }
                }
            }
            
            // Recursively check sub_folders
            if (node.sub_folders && Array.isArray(node.sub_folders)) {
                for (const subFolder of node.sub_folders) {
                    const subPath = path ? `${path}/${subFolder.folder_name}` : subFolder.folder_name;
                    if (checkInNode(subFolder, subPath)) {
                        return true;
                    }
                }
            }
            
            return false;
        };
        
        return checkInNode(tree);
    };

    // Helper to find file URL from allFiles array by filename
    const findFileUrl = (fileName) => {
        if (!rowData.allFiles || !Array.isArray(rowData.allFiles)) return null;
        // Normalize filenames for comparison (remove special chars, lowercase, handle URL encoding)
        const normalize = (name) => {
            return decodeURIComponent(name).toLowerCase().replace(/[^a-z0-9]/g, '');
        };
        const normalizedTarget = normalize(fileName);
        return rowData.allFiles.find(url => {
            const urlFileName = getFileNameFromUrl(url);
            const normalizedUrl = normalize(urlFileName);
            // Try exact match first, then partial match
            return normalizedUrl === normalizedTarget || 
                   normalizedUrl.includes(normalizedTarget) || 
                   normalizedTarget.includes(normalizedUrl) ||
                   urlFileName === fileName ||
                   urlFileName.includes(fileName);
        });
    };

    // Toggle file selection in folder tree
    const toggleFileSelection = (fileName, fileUrlFromFile = null) => {
        const fileUrl = fileUrlFromFile || findFileUrl(fileName);
        if (!fileUrl) return;
        
        // Check if file is .xlsx or .csv - these should not be selectable
        const extension = fileName.split('.').pop()?.toLowerCase() || '';
        const isExcelOrCsv = extension === 'xlsx' || extension === 'csv';
        if (isExcelOrCsv) {
            showSnackbar('XLSX and CSV files cannot be selected. They are shown for reference only.', 'info');
            return;
        }
        
        // Check if document type is selected before allowing file selection
        if (!documentType || documentType.trim() === '') {
            showSnackbar('Please select Document Type before selecting files.', 'warning');
            return;
        }
        
        setSelectedFileUrls(prev => {
            const newSet = new Set(prev);
            if (newSet.has(fileUrl)) {
                newSet.delete(fileUrl);
            } else {
                // No limit on number of files - user can select as many as they want
                newSet.add(fileUrl);
            }
            return newSet;
        });
    };

    // Handle starting file rename
    const handleStartRename = (e, fileName, fileUrl) => {
        e.stopPropagation();
        setEditingFile(fileUrl);
        setEditingFileName(fileName);
    };

    // Handle canceling rename
    const handleCancelRename = (e) => {
        e.stopPropagation();
        setEditingFile(null);
        setEditingFileName('');
    };

    // Handle saving renamed file
    const handleSaveRename = async (e, oldFileName, fileUrl) => {
        e.stopPropagation();
        if (!editingFileName || editingFileName.trim() === '') {
            showSnackbar('File name cannot be empty.', 'error');
            return;
        }

        if (editingFileName === oldFileName) {
            // No change, just cancel
            handleCancelRename(e);
            return;
        }

        try {
            // Call API to rename file
            const storedData = JSON.parse(localStorage.getItem('userDetails'));
            const userid = storedData.userDetails.id;

            const response = await axios.post(`${baseApiUrl}/dashboard/listdocumnets/file_rename`, {
                rfpid: id,
                old_file_name: oldFileName,
                new_file_name: editingFileName.trim(),
                file_url: fileUrl,
                userid: userid
            });

            if (response.data.status_code === 200) {
                showSnackbar('File renamed successfully.', 'success');
                setEditingFile(null);
                setEditingFileName('');
                // Refresh RFP data to get updated file names
                fetchrfpData();
            } else {
                showSnackbar(response.data.message || 'Failed to rename file.', 'error');
            }
        } catch (error) {
            console.error('Error renaming file:', error);
            showSnackbar(error.response?.data?.message || 'Failed to rename file. Please try again.', 'error');
        }
    };

    // Function to check if a folder contains any selected files (recursively)
    const folderContainsSelectedFiles = (folderData) => {
        if (!folderData) return false;
        
        // Check files in current folder
        if (folderData.files && Array.isArray(folderData.files)) {
            for (const file of folderData.files) {
                const fileUrl = file.file_url || findFileUrl(file.file_name);
                if (fileUrl && selectedFileUrls.has(fileUrl)) {
                    return true;
                }
            }
        }
        
        // Recursively check sub-folders
        if (folderData.sub_folders && Array.isArray(folderData.sub_folders)) {
            for (const subFolder of folderData.sub_folders) {
                if (folderContainsSelectedFiles(subFolder)) {
                    return true;
                }
            }
        }
        
        return false;
    };

    // Handle delete file
    const handleDeleteFile = async (fileName, fileUrl) => {
        try {
            setLoading(true);
            const params = new URLSearchParams({
                rfpid: id,
                file_url: fileUrl
            });
            if (fileName) {
                params.append('file_name', fileName);
            }
            const response = await axios.delete(`${baseApiUrl}/dashboard/listdocuments/delete_file?${params.toString()}`);
            
            if (response.data.status_code === 200) {
                showSnackbar('File deleted successfully.', 'success');
                
                // Remove from selectedFileUrls if present
                setSelectedFileUrls(prev => {
                    const newSet = new Set(prev);
                    if (fileUrl && newSet.has(fileUrl)) {
                        newSet.delete(fileUrl);
                    }
                    return newSet;
                });
                
                // Refresh RFP data to update tree structure
                await fetchrfpData();
                await fetchDocuments();
            } else {
                showSnackbar(response.data.message || 'Failed to delete file.', 'error');
            }
        } catch (error) {
            console.error('Error deleting file:', error);
            showSnackbar(error.response?.data?.message || 'Failed to delete file. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Handle delete folder
    const handleDeleteFolder = async (folderName, folderPath = null) => {
        try {
            setLoading(true);
            const params = new URLSearchParams({
                rfpid: id,
                folder_name: folderName
            });
            if (folderPath) {
                params.append('folder_path', folderPath);
            }
            const response = await axios.delete(`${baseApiUrl}/dashboard/listdocuments/delete_file?${params.toString()}`);
            
            if (response.data.status_code === 200) {
                showSnackbar('Folder deleted successfully.', 'success');
                
                // Refresh RFP data to update tree structure
                await fetchrfpData();
                await fetchDocuments();
            } else {
                showSnackbar(response.data.message || 'Failed to delete folder.', 'error');
            }
        } catch (error) {
            console.error('Error deleting folder:', error);
            showSnackbar(error.response?.data?.message || 'Failed to delete folder. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Recursive function to render folder tree structure
    const renderFolderTree = (folderData, level = 0, parentPath = '') => {
        if (!folderData) return null;
        
        const items = [];
        const indent = '│  '.repeat(level);
        
        // Render files first (so they appear directly under their folder)
        if (folderData.files && Array.isArray(folderData.files)) {
            folderData.files.forEach((file, idx) => {
                const isLast = idx === folderData.files.length - 1 && (!folderData.sub_folders || folderData.sub_folders.length === 0);
                const connector = isLast ? '└── ' : '├── ';
                // Use file_url if available (from buildTreeFromFiles), otherwise find it
                const fileUrl = file.file_url || findFileUrl(file.file_name);
                
                // Check if file is .xlsx or .csv - these should not be selectable
                const fileName = file.file_name || '';
                const extension = fileName.split('.').pop()?.toLowerCase() || '';
                const isExcelOrCsv = extension === 'xlsx' || extension === 'csv';
                
                // Separate initial selection (from backend) vs user selection
                const isInitiallySelected = file.is_selected === true; // Files initially selected from backend
                const isUserSelected = fileUrl && selectedFileUrls.has(fileUrl); // Files selected by user clicking
                const isSelected = isInitiallySelected || isUserSelected; // Visual highlight for both
                const isDisabled = isInitiallySelected || isExcelOrCsv; // Disable initially selected files and .xlsx/.csv files
                
                const isEditing = editingFile === fileUrl;
                
                items.push(
                    <Box 
                        key={`file-${parentPath}-${file.file_name}-${idx}`}
                        onClick={isEditing ? undefined : (isDisabled ? undefined : () => toggleFileSelection(file.file_name, file.file_url))}
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            mb: 0.5,
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            cursor: isEditing ? 'default' : (isDisabled ? (isExcelOrCsv ? 'default' : 'not-allowed') : 'pointer'),
                            padding: '4px 8px',
                            borderRadius: '4px',
                            backgroundColor: isSelected && !isExcelOrCsv ? '#e3f2fd' : 'transparent',
                            opacity: isDisabled && !isExcelOrCsv ? 0.7 : 1,
                            '&:hover': (isDisabled || isEditing) ? {} : { backgroundColor: isSelected && !isExcelOrCsv ? '#bbdefb' : (isExcelOrCsv ? 'transparent' : '#f0f0f0') }
                        }}
                    >
                        {isEditing ? (
                            // Editing mode - show input field
                            <>
                                <Typography sx={{ 
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '12px',
                                    whiteSpace: 'pre',
                                    marginRight: '8px'
                                }}>
                                    {indent}{connector}📄
                                </Typography>
                                <TextField
                                    value={editingFileName}
                                    onChange={(e) => setEditingFileName(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSaveRename(e, file.file_name, fileUrl);
                                        } else if (e.key === 'Escape') {
                                            handleCancelRename(e);
                                        }
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                    autoFocus
                                    size="small"
                                    sx={{
                                        flex: 1,
                                        '& .MuiOutlinedInput-root': {
                                            fontSize: '12px',
                                            padding: '2px 8px',
                                            height: '24px'
                                        }
                                    }}
                                />
                                <IconButton
                                    size="small"
                                    onClick={(e) => handleSaveRename(e, file.file_name, fileUrl)}
                                    sx={{ 
                                        padding: '2px',
                                        marginLeft: '4px',
                                        color: '#4caf50',
                                        '&:hover': { backgroundColor: '#e8f5e9' }
                                    }}
                                    title="Save"
                                >
                                    <SaveIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={handleCancelRename}
                                    sx={{ 
                                        padding: '2px',
                                        marginLeft: '2px',
                                        color: '#f44336',
                                        '&:hover': { backgroundColor: '#ffebee' }
                                    }}
                                    title="Cancel"
                                >
                                    <CancelIcon fontSize="small" />
                                </IconButton>
                            </>
                        ) : (
                            // Normal mode - show file name
                            <>
                                <Typography sx={{ 
                                    color: isSelected ? '#1976d2' : '#333',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '12px',
                                    whiteSpace: 'pre',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    flex: 1,
                                    minWidth: 0,
                                    textAlign: 'left',
                                    fontWeight: isSelected ? 600 : 400
                                }}
                                title={`${indent}${connector}📄 ${file.file_name}`}
                                >
                                    {indent}{connector}📄 {file.file_name}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    {!isDisabled && !isExcelOrCsv && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => handleStartRename(e, file.file_name, fileUrl)}
                                            sx={{ 
                                                padding: '2px',
                                                color: '#666',
                                                '&:hover': { 
                                                    backgroundColor: '#e3f2fd',
                                                    color: '#1976d2'
                                                }
                                            }}
                                            title="Rename file"
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                    {/* Always show delete button for .xlsx and .csv files, or show when not selected for other files */}
                                    {(isExcelOrCsv || !isSelected) && (
                                    <Tooltip title="Delete File" arrow>
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteFile(file.file_name, fileUrl);
                                            }}
                                            sx={{
                                                padding: '2px',
                                                color: '#d32f2f',
                                                '&:hover': {
                                                    backgroundColor: '#ffebee'
                                                }
                                            }}
                                        >
                                            <img 
                                                src={Trash_Empty} 
                                                width="16px" 
                                                height="16px" 
                                                alt="delete" 
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    )}
                                    {isSelected && !isExcelOrCsv && (
                                        <Box sx={{ 
                                            color: '#4caf50',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <CheckIcon fontSize="small" />
                                        </Box>
                                    )}
                                </Box>
                            </>
                        )}
                    </Box>
                );
            });
        }
        
        // Render sub-folders
        if (folderData.sub_folders && Array.isArray(folderData.sub_folders)) {
            folderData.sub_folders.forEach((subFolder, idx) => {
                const isLast = idx === folderData.sub_folders.length - 1;
                const connector = isLast ? '└── ' : '├── ';
                const fullPath = parentPath ? `${parentPath}/${subFolder.folder_name}` : subFolder.folder_name;
                
                items.push(
                    <Box key={`folder-${fullPath}`} sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 0.5,
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '12px',
                        overflow: 'hidden'
                    }}>
                        <Typography sx={{ 
                            color: '#2196f3',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            whiteSpace: 'pre',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1,
                            minWidth: 0,
                            textAlign: 'left'
                        }}
                        title={`${indent}${connector}📁 ${subFolder.folder_name}`}
                        >
                            {indent}{connector}📁 {subFolder.folder_name}
                        </Typography>
                        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleUploadMenuOpen(e, false, fullPath);
                                }}
                                sx={{
                                    padding: '2px',
                                    marginLeft: '8px',
                                    color: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#e3f2fd'
                                    }
                                }}
                                title="Upload files or folder"
                            >
                                <AddIcon fontSize="small" />
                            </IconButton>
                            <Menu
                                anchorEl={uploadMenuAnchor}
                                open={Boolean(uploadMenuAnchor)}
                                onClose={handleUploadMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >
                                <MenuItem onClick={handleUploadFile}>
                                    📄 Upload File
                                </MenuItem>
                                {/* Only show Upload Folder for root folder */}
                                {isRootFolderMenu && (
                                    <MenuItem onClick={handleUploadFolder}>
                                        📁 Upload Folder
                                    </MenuItem>
                                )}
                            </Menu>
                        </Box>
                    </Box>
                );
                
                // Recursively render sub-folder contents
                const subItems = renderFolderTree(subFolder, level + 1, fullPath);
                if (subItems) {
                    items.push(...subItems);
                }
            });
        }
        
        return items;
    };

    const handleDocumentClick = (document) => {
        // Only allow clicking on RFP documents
        if (document.doc_type !== "RFP") {
            return;
        }
        setLoading(true);
        axios.get(`${baseApiUrl}/doc_extract/get_pdf`, {
            params: { doc_id: document.doc_id, rfpid: id }
        })
            .then((response) => {
                setDocResponse(response.data.results)
                setSelectedDocument(document);
                setShowMicrosoftRFP(true);
                setLoading(false);
                setSpecDocId(document?.doc_id);
            })
            .catch((error) => {
                console.error('Error fetching document:', error);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        fetchrfpData();
        fetchDocuments();
    }, []);

    // Auto-load main RFP document when documents are fetched (only if it's RFP type)
    useEffect(() => {
        if (documents.length > 0 && !selectedDocument) {
            const mainRfpDocument = documents.find(doc => doc.main_rfp === true && doc.doc_type === "RFP");
            if (mainRfpDocument) {
                handleDocumentClick(mainRfpDocument);
            }
        }
    }, [documents, selectedDocument]);


    const handleDeleteDocument = async () => {
        setLoading(true);
        try {
            const response = await axios.delete(`${baseApiUrl}/dashboard/listdocumnets/del_doc`, {
                data: {
                    rfpid: id,
                    doc_name: documentToDelete.doc_name
                }
            });
            if (response.data.status_code === 200) {
                // Get the document name and URL
                const deletedDocName = documentToDelete.doc_name;
                const deletedFileUrl = documentToDelete.doc_url || documentToDelete.file_url;
                
                // Remove the deleted file from selectedFileUrls
                // Try multiple approaches to find and remove the file URL
                setSelectedFileUrls(prev => {
                    const newSet = new Set(prev);
                    let removed = false;
                    
                    // Method 1: Try direct URL match
                    if (deletedFileUrl && newSet.has(deletedFileUrl)) {
                        newSet.delete(deletedFileUrl);
                        removed = true;
                    }
                    
                    // Method 2: Find file URL by matching document name with file names in tree
                    // Check all URLs in selectedFileUrls and find the one matching the document name
                    if (!removed && deletedDocName && rowData.allFiles) {
                        newSet.forEach(url => {
                            const urlFileName = getFileNameFromUrl(url);
                            // Normalize both names for comparison
                            const normalize = (name) => {
                                if (!name) return '';
                                return decodeURIComponent(String(name)).toLowerCase().trim().replace(/[^a-z0-9]/g, '');
                            };
                            
                            const normalizedDocName = normalize(deletedDocName);
                            const normalizedUrlName = normalize(urlFileName);
                            
                            // Check if names match (handling URL encoding, spaces, etc.)
                            if (normalizedDocName === normalizedUrlName || 
                                urlFileName === deletedDocName ||
                                urlFileName.includes(deletedDocName) ||
                                deletedDocName.includes(urlFileName)) {
                                newSet.delete(url);
                                removed = true;
                            }
                        });
                    }
                    
                    return newSet;
                });
                
                // Refresh documents list first
                await fetchDocuments();
                
                // Refresh RFP data to update tree structure
                // fetchrfpData now filters out deleted files automatically
                await fetchrfpData();
                
                // Double-check: Remove deleted file from selectedFileUrls if still present
                setSelectedFileUrls(prev => {
                    const newSet = new Set(prev);
                    let updated = false;
                    
                    // Remove by direct URL match
                    if (deletedFileUrl && newSet.has(deletedFileUrl)) {
                        newSet.delete(deletedFileUrl);
                        updated = true;
                    }
                    
                    // Remove by matching document name
                    if (deletedDocName) {
                        newSet.forEach(url => {
                            const urlFileName = getFileNameFromUrl(url);
                            const normalize = (name) => {
                                if (!name) return '';
                                return decodeURIComponent(String(name)).toLowerCase().trim().replace(/[^a-z0-9]/g, '');
                            };
                            
                            const normalizedDocName = normalize(deletedDocName);
                            const normalizedUrlName = normalize(urlFileName);
                            
                            if (normalizedDocName === normalizedUrlName || 
                                urlFileName === deletedDocName) {
                                newSet.delete(url);
                                updated = true;
                            }
                        });
                    }
                    
                    return updated ? newSet : prev;
                });
                
                showSnackbar("Document deleted successfully", "success");
                handleCloseDeleteModal();
                setLoading(false);
            }

        } catch (error) {
            console.error("Delete failed:", error.response.data.message);
            setLoading(false);
        }
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);

    };

    const handleOpenDeleteModal = (doc) => {
        setDocumentToDelete(doc);
        setDeleteModalOpen(true);
    };
    const handleCloseDeleteModal = () => {
        setDeleteModalOpen(false);
        setDocumentToDelete(null);
    };

    const handleBackdetails = () => {
        navigate('/dashboard');
    };
    // Helper function to find URL from document name
    const findDocumentUrl = (docName) => {
        if (!docName || !rowData.allFiles) return null;
        
        // Normalize the document name for comparison
        const normalizeName = (name) => {
            if (!name) return '';
            return decodeURIComponent(String(name)).toLowerCase().trim().replace(/[^a-z0-9]/g, '');
        };
        
        const normalizedDocName = normalizeName(docName);
        
        // Search in allFiles array
        for (const fileUrl of rowData.allFiles) {
            if (!fileUrl) continue;
            const fileName = getFileNameFromUrl(fileUrl);
            if (normalizeName(fileName) === normalizedDocName) {
                return fileUrl;
            }
        }
        
        return null;
    };

    const pdfOpenDeatils = (docUrl, doc = null) => {
        let finalUrl = docUrl;
        
        // If docUrl is not available, try to find it from document object or allFiles
        if (!finalUrl || finalUrl === 'null' || finalUrl === 'undefined' || finalUrl.trim() === '') {
            if (doc) {
                // Try doc.file_url as fallback
                finalUrl = doc.file_url || null;
                
                // If still not found, try to find from allFiles using doc_name
                if (!finalUrl && doc.doc_name) {
                    finalUrl = findDocumentUrl(doc.doc_name);
                }
            }
            
            // If still no URL found, show error
            if (!finalUrl || finalUrl === 'null' || finalUrl === 'undefined' || finalUrl.trim() === '') {
                showSnackbar('Document URL is not available. Please contact support.', 'error');
                return;
            }
        }
        
        // Validate URL format
        try {
            // Check if it's a valid URL format
            if (!finalUrl.startsWith('http://') && !finalUrl.startsWith('https://')) {
                showSnackbar('Invalid document URL format.', 'error');
                return;
            }
            
            // Try to create a URL object to validate
            new URL(finalUrl);
            
            // Get the file name from the document object, or extract from URL as fallback
            const fileName = doc?.doc_name || doc?.file_name || (() => {
                try {
                    const urlObj = new URL(finalUrl);
                    const pathname = urlObj.pathname;
                    const segments = pathname.split('/').filter(Boolean);
                    return segments[segments.length - 1] || 'Document';
                } catch {
                    return 'Document';
                }
            })();
            
            navigate(`/view-document/${encodeURIComponent(finalUrl)}`, { state: { fileName: fileName, rfpIssuer: rowData.rfp_issuer } });
        } catch (error) {
            console.error('Invalid document URL:', error);
            showSnackbar('Invalid document URL. Please contact support.', 'error');
        }
    }

    const handleBackButtonClick = () => {
        setShowMicrosoftRFP(false);
    };

    const handleEditPage = () => {
        // Helper function to format date with timezone
        const formatDateWithTimezone = (date, timezone) => {
            if (!date) return '';
            if (!timezone) return date;

            // Check if the date already contains timezone information
            if (date.includes('(') || /[A-Z]{2,4}$/.test(date)) {
                return date; // Already formatted
            }

            return `${date} (${timezone})`;
        };

        // Format the data to include timezone information in date fields
        const formattedData = {
            ...rowData,
            first_review: formatDateWithTimezone(rowData.first_review, rowData.first_review_date_timezone),
            conference_date: formatDateWithTimezone(rowData.conference_date, rowData.conference_date_timezone),
            questionnaire_date: formatDateWithTimezone(rowData.questionnaire_date, rowData.questionnaire_date_timezone),
            submission_date: formatDateWithTimezone(rowData.submission_date, rowData.submission_date_timezone),
        };

        navigate(`/MicrosoftRFPDetailsEditPage/${id}`, { state: { formData: formattedData } })
    }
 
    const handleDocument = () => {

        navigate(`/ResponseDocument/${id}`, { state: { rfpIssuer: rowData.rfp_issuer,file_name:fileUploadedName } });
    }



    const simulateFileUpload = useCallback((currentProgress = 0) => {
        uploadTimer.current = setInterval(() => {
            if (currentProgress < 90) {
                currentProgress += 5;
                setProgress(currentProgress);
            }
        }, 500);
    }, []);

    // Handle single file upload
    const handleFileChange = async (event) => {
        const uploadedFile = event.target.files[0];
        if (!uploadedFile) return;
        
        const fileSizeInMB = uploadedFile.size / (1024 * 1024);
        if (fileSizeInMB > 20) {
            showSnackbar('File size exceeds greater than 20MB. Please upload a smaller file.', 'error');
            event.target.value = null;
            return;
        }
        
        // If uploading to a specific folder (via + button), show confirmation modal
        if (targetFolderPath) {
            // Store file and folder info for confirmation modal
            setPendingUploadFile(uploadedFile);
            setPendingUploadFolderName(targetFolderPath);
            setPendingUploadType('file');
            setConfirmUploadModalOpen(true);
            event.target.value = null; // Clear file input for now
        } else {
            // Normal upload (not to a specific folder) - show in Document Name field
            simulateFileUpload();
            const base64 = await convertToBase64(uploadedFile);
            setFile({
                ...uploadedFile,
                base64,
                readableSize: formatFileSize(uploadedFile.size)
            });
            setFiles([uploadedFile]);
            setFileName(uploadedFile.name);
        }
    }

    // Handle folder upload
    const handleFolderChange = async (event) => {
        const uploadedFiles = Array.from(event.target.files);
        if (uploadedFiles.length === 0) return;
        
        // Validate file sizes
        const invalidFiles = uploadedFiles.filter(file => {
            const fileSizeInMB = file.size / (1024 * 1024);
            return fileSizeInMB > 20;
        });

        if (invalidFiles.length > 0) {
            showSnackbar(`${invalidFiles.length} file(s) exceed 20MB limit. Please select smaller files.`, 'error');
            event.target.value = null;
            return;
        }

        // Validate file types
        const validExtensions = ['.pdf', '.doc', '.docx', '.xlsx', '.csv'];
        const invalidTypeFiles = uploadedFiles.filter(file => {
            const extension = '.' + file.name.split('.').pop().toLowerCase();
            return !validExtensions.includes(extension);
        });

        if (invalidTypeFiles.length > 0) {
            showSnackbar(`${invalidTypeFiles.length} file(s) have invalid format. Only PDF, DOC, DOCX, XLSX, CSV files are allowed.`, 'error');
            event.target.value = null;
            return;
        }

        // If uploading to a specific folder (via + button), show confirmation modal
        if (targetFolderPath) {
            // Store files and folder info for confirmation modal
            setPendingUploadFiles(uploadedFiles);
            setPendingUploadFolderName(targetFolderPath);
            setPendingUploadType('folder');
            setConfirmUploadModalOpen(true);
            event.target.value = null; // Clear file input for now
        } else {
            // Normal folder upload (not via + button) - existing flow
            setFiles(uploadedFiles);
            setFile(uploadedFiles[0]); // Keep first file for backward compatibility
            setFileName(uploadedFiles[0]?.name || '');
            showSnackbar(`Selected folder with ${uploadedFiles.length} files`, 'info');
        }
    }

    // Handle upload menu open
    const handleUploadMenuOpen = (event, isRoot = false, folderPath = '') => {
        event.stopPropagation();
        setUploadMenuAnchor(event.currentTarget);
        setIsRootFolderMenu(isRoot);
        setTargetFolderPath(folderPath); // Store the folder path where files should be uploaded
    };

    // Handle upload menu close
    const handleUploadMenuClose = (keepFolderPath = false) => {
        setUploadMenuAnchor(null);
        setIsRootFolderMenu(false);
        // Only reset folder path if we're not about to upload (keepFolderPath = false)
        if (!keepFolderPath) {
            setTargetFolderPath('');
        }
    };

    // Trigger file input
    const handleUploadFile = () => {
        handleUploadMenuClose(true); // Keep folder path for upload
        document.getElementById('raised-button-file').click();
    };

    // Handle confirmation and upload file
    const handleConfirmUpload = async () => {
        if (pendingUploadType === 'folder') {
            await handleConfirmFolderUpload();
        } else {
            await handleConfirmFileUpload();
        }
    };

    // Handle confirmation and upload single file
    const handleConfirmFileUpload = async () => {
        if (!pendingUploadFile || !pendingUploadFolderName) {
            showSnackbar('No file selected for upload.', 'error');
            setConfirmUploadModalOpen(false);
            return;
        }

        setConfirmUploadModalOpen(false);
        setAddDocLoading(true);
        setUploading(true);
        setIsCloseDisabled(true);
        setProgress(0);

        try {
            const storedData = JSON.parse(localStorage.getItem('userDetails'));
            const userid = storedData.userDetails.id;

            // Check for duplicates using normalized names
            let folderTree = null;
            if (rowData.allFiles && rowData.allFiles.length > 0) {
                folderTree = buildTreeFromFiles(rowData.allFiles, rowData.selectedFiles);
            } else if (rowData.structure) {
                folderTree = rowData.structure;
            }
            
            // Check if file already exists (checkFileExistsInTree normalizes names internally)
            if (folderTree && checkFileExistsInTree(folderTree, pendingUploadFile.name)) {
                showSnackbar(`File "${pendingUploadFile.name}" already exists in the folder structure. Please use a different file name.`, 'error');
                setAddDocLoading(false);
                setUploading(false);
                setIsCloseDisabled(false);
                return;
            }

            // Build FormData according to backend format for single file upload
            // Use ORIGINAL file name (not sanitized)
            const formData = new FormData();
            formData.append('user_id', userid);
            formData.append('rfp_id', id);
            formData.append('folder_structure', JSON.stringify([])); // Empty array for single file upload
            formData.append('all_files', pendingUploadFile, pendingUploadFile.name);
            formData.append('path', pendingUploadFolderName);
            formData.append('mode', 'single'); // Use "single" mode for single file upload

            simulateFileUpload();
            const response = await axios.post(`${baseApiUrl}/listdocumnets/upload_file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'accept': 'application/json'
                }
            });

            if (response.data.status_code === 200) {
                // Add uploaded file directly to tree structure
                let newFileUrls = [];
                
                // Check multiple possible response formats
                if (response.data.file_urls && Array.isArray(response.data.file_urls)) {
                    newFileUrls = response.data.file_urls.filter(url => url && !url.endsWith('/'));
                } else if (response.data.file_url && typeof response.data.file_url === 'string') {
                    newFileUrls = [response.data.file_url];
                } else if (response.data.details && response.data.details.file_url) {
                    newFileUrls = [response.data.details.file_url];
                } else if (response.data.results && Array.isArray(response.data.results)) {
                    response.data.results.forEach(result => {
                        if (result.file_url) newFileUrls.push(result.file_url);
                        if (result.doc_url) newFileUrls.push(result.doc_url);
                    });
                }
                
                // Update rowData with new file URLs
                if (newFileUrls.length > 0) {
                    setRowData(prevData => {
                        const updatedAllFiles = [...(prevData.allFiles || []), ...newFileUrls];
                        
                        // Rebuild tree structure with new files
                        const updatedTree = buildTreeFromFiles(updatedAllFiles, prevData.selectedFiles || []);
                        
                        return {
                            ...prevData,
                            allFiles: updatedAllFiles,
                            structure: updatedTree || prevData.structure,
                            mode: 'folder' // Always set mode to folder when files are uploaded
                        };
                    });
                    
                    // Ensure folder tree is visible
                    setShowFolderTree(true);
                    
                    // Fetch updated structure from backend to ensure consistency
                    setTimeout(() => {
                        fetchUpdatedFolderStructure(response.data);
                    }, 500);
                }
                
                setTargetFolderPath('');
                setProgress(100);
                showSnackbar(response.data.message || 'File uploaded successfully to folder.', 'success');
                
                // Clear pending upload data
                setPendingUploadFile(null);
                setPendingUploadFolderName('');
                setPendingUploadType('file');
            } else {
                showSnackbar(response.data.message || 'Upload failed. Please try again.', 'error');
            }
        } catch (error) {
            console.error("Upload failed:", error);
            showSnackbar('Upload failed: Please try again.', 'error');
            setProgress(0);
        } finally {
            setAddDocLoading(false);
            setUploading(false);
            clearInterval(uploadTimer.current);
            setIsCloseDisabled(false);
            setPendingUploadFile(null);
            setPendingUploadFolderName('');
            setPendingUploadType('file');
        }
    };

    // Handle confirmation and upload folder
    const handleConfirmFolderUpload = async () => {
        if (!pendingUploadFiles || pendingUploadFiles.length === 0 || !pendingUploadFolderName) {
            showSnackbar('No folder selected for upload.', 'error');
            setConfirmUploadModalOpen(false);
            return;
        }

        // Check for duplicate files before uploading
        let folderTree = null;
        
        // Build tree from existing files to check for duplicates
        if (rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0) {
            folderTree = buildTreeFromFiles(rowData.allFiles, rowData.selectedFiles);
        } else if (rowData.structure && (rowData.structure.files?.length > 0 || rowData.structure.sub_folders?.length > 0)) {
            folderTree = rowData.structure;
        }
        
        // Check each file for duplicates using normalized comparison
        // checkFileExistsInTree already normalizes names internally, so pass original names
        const duplicateFiles = [];
        for (const file of pendingUploadFiles) {
            const fileName = file.name;
            
            // Check if file exists (normalization happens inside checkFileExistsInTree)
            if (folderTree && checkFileExistsInTree(folderTree, fileName)) {
                duplicateFiles.push(fileName);
            }
        }
        
        // If duplicates found, show error and prevent upload
        if (duplicateFiles.length > 0) {
            const duplicateList = duplicateFiles.length <= 5 
                ? duplicateFiles.join(', ') 
                : `${duplicateFiles.slice(0, 5).join(', ')} and ${duplicateFiles.length - 5} more`;
            showSnackbar(
                `Cannot upload folder: The following file(s) already exist in the folder structure: ${duplicateList}. Please remove or rename them before uploading.`, 
                'error'
            );
            setConfirmUploadModalOpen(false);
            setPendingUploadFiles([]);
            setPendingUploadFolderName('');
            setPendingUploadType('file');
            return;
        }

        setConfirmUploadModalOpen(false);
        setAddDocLoading(true);
        setUploading(true);
        setIsCloseDisabled(true);
        setProgress(0);

        try {
            const storedData = JSON.parse(localStorage.getItem('userDetails'));
            const userid = storedData.userDetails.id;

            // Extract folder name from first file's webkitRelativePath
            // Example: "folder_name/file1.pdf" -> folder_name is "folder_name"
            const firstFile = pendingUploadFiles[0];
            const folderPath = firstFile.webkitRelativePath || firstFile.name;
            const pathParts = folderPath.split('/');
            const folderName = pathParts.length > 1 ? pathParts[0] : 'Uploaded_Folder';

            // Build nested folder_structure JSON with subfolders
            // Format: {"folder_name":"folder_name","files":[{...}],"sub_folders":[{...}]}
            // This structure represents the folder being uploaded (child of parent folder)
            const buildNestedFolderStructure = (files) => {
                // Build a nested structure from files, removing the root folder name from paths
                const structure = {};
                
                files.forEach(file => {
                    const filePath = file.webkitRelativePath || file.name;
                    const pathParts = filePath.split('/');
                    const fileName = pathParts[pathParts.length - 1];
                    
                    // Remove root folder name from path (first part)
                    // Example: "root_folder/sub_folder/file.pdf" -> ["sub_folder"] for folderParts
                    const folderParts = pathParts.length > 1 ? pathParts.slice(1, -1) : [];
                    
                    // Navigate/create folder structure
                    let current = structure;
                    folderParts.forEach((subFolderName) => {
                        if (!current[subFolderName]) {
                            current[subFolderName] = {
                                folder_name: subFolderName,
                                files: [],
                                sub_folders: {}
                            };
                        }
                        current = current[subFolderName].sub_folders;
                    });
                    
                    // Add file to the appropriate location
                    if (folderParts.length === 0) {
                        // Root level file (directly in the uploaded folder)
                        if (!structure.files) {
                            structure.files = [];
                        }
                        structure.files.push({
                            file_name: fileName
                        });
                    } else {
                        // File in a subfolder
                        let deepestFolder = structure;
                        folderParts.forEach(folderName => {
                            deepestFolder = deepestFolder[folderName];
                        });
                        if (!deepestFolder.files) {
                            deepestFolder.files = [];
                        }
                        deepestFolder.files.push({
                            file_name: fileName
                        });
                    }
                });
                
                // Convert nested object structure to array format
                const convertToArrayFormat = (node) => {
                    if (!node || typeof node !== 'object') {
                        return null;
                    }
                    
                    // If it's a folder structure (has folder_name)
                    if (node.folder_name) {
                        return {
                            folder_name: node.folder_name,
                            files: (node.files || []).sort((a, b) => (a.file_name || '').localeCompare(b.file_name || '')),
                            sub_folders: Object.values(node.sub_folders || {})
                                .map(subFolder => convertToArrayFormat(subFolder))
                                .filter(subFolder => subFolder !== null)
                                .sort((a, b) => (a.folder_name || '').localeCompare(b.folder_name || ''))
                        };
                    }
                    
                    // Root level - combine root files and subfolders
                    const rootKeys = Object.keys(node).filter(key => 
                        node[key] && node[key].folder_name && typeof node[key] === 'object'
                    );
                    const rootFiles = node.files || [];
                    
                    return {
                        folder_name: folderName,
                        files: rootFiles.sort((a, b) => (a.file_name || '').localeCompare(b.file_name || '')),
                        sub_folders: rootKeys
                            .map(key => convertToArrayFormat(node[key]))
                            .filter(folder => folder !== null)
                            .sort((a, b) => (a.folder_name || '').localeCompare(b.folder_name || ''))
                    };
                };
                
                return convertToArrayFormat(structure);
            };

            let folderStructure = buildNestedFolderStructure(pendingUploadFiles);
            
            // Ensure folderStructure has the correct format
            if (!folderStructure || !folderStructure.folder_name) {
                folderStructure = {
                    folder_name: folderName,
                    files: pendingUploadFiles.map(file => {
                        const filePath = file.webkitRelativePath || file.name;
                        const pathParts = filePath.split('/');
                        const fileName = pathParts[pathParts.length - 1];
                        return {
                            file_name: fileName
                        };
                    }),
                    sub_folders: []
                };
            }

            // Build FormData according to backend format for folder upload
            const formData = new FormData();
            formData.append('user_id', userid);
            formData.append('rfp_id', id);
            formData.append('folder_structure', JSON.stringify(folderStructure));
            
            // Append all files with ORIGINAL names (not sanitized)
            pendingUploadFiles.forEach(file => {
                formData.append('all_files', file, file.name);
            });
            
            formData.append('path', pendingUploadFolderName); // Parent folder path where this folder will be uploaded as child
            formData.append('mode', 'folder'); // Use "folder" mode for folder upload

            simulateFileUpload();
            const response = await axios.post(`${baseApiUrl}/listdocumnets/upload_file`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'accept': 'application/json'
                }
            });

            if (response.data.status_code === 200) {
                // Add uploaded files directly to tree structure
                let newFileUrls = [];
                
                // Check multiple possible response formats
                if (response.data.file_urls && Array.isArray(response.data.file_urls)) {
                    newFileUrls = response.data.file_urls.filter(url => url && !url.endsWith('/'));
                } else if (response.data.file_url && typeof response.data.file_url === 'string') {
                    newFileUrls = [response.data.file_url];
                } else if (response.data.details && response.data.details.file_url) {
                    newFileUrls = [response.data.details.file_url];
                } else if (response.data.results && Array.isArray(response.data.results)) {
                    response.data.results.forEach(result => {
                        if (result.file_url) newFileUrls.push(result.file_url);
                        if (result.doc_url) newFileUrls.push(result.doc_url);
                    });
                }
                
                // Update rowData with new file URLs
                if (newFileUrls.length > 0) {
                    setRowData(prevData => {
                        const updatedAllFiles = [...(prevData.allFiles || []), ...newFileUrls];
                        
                        // Rebuild tree structure with new files
                        const updatedTree = buildTreeFromFiles(updatedAllFiles, prevData.selectedFiles || []);
                        
                        return {
                            ...prevData,
                            allFiles: updatedAllFiles,
                            structure: updatedTree || prevData.structure,
                            mode: 'folder'
                        };
                    });
                    
                    // Ensure folder tree is visible
                    setShowFolderTree(true);
                    
                    // Fetch updated structure from backend to ensure consistency
                    setTimeout(() => {
                        fetchUpdatedFolderStructure(response.data);
                    }, 500);
                }
                
                setTargetFolderPath('');
                setProgress(100);
                showSnackbar(response.data.message || `Folder "${folderName}" uploaded successfully.`, 'success');
                
                // Clear pending upload data
                setPendingUploadFiles([]);
                setPendingUploadFolderName('');
                setPendingUploadType('file');
            } else {
                showSnackbar(response.data.message || 'Upload failed. Please try again.', 'error');
            }
        } catch (error) {
            console.error("Upload failed:", error);
            showSnackbar('Upload failed: Please try again.', 'error');
            setProgress(0);
        } finally {
            setAddDocLoading(false);
            setUploading(false);
            clearInterval(uploadTimer.current);
            setIsCloseDisabled(false);
            setPendingUploadFiles([]);
            setPendingUploadFolderName('');
            setPendingUploadType('file');
        }
    };

    // Handle cancel confirmation
    const handleCancelConfirmUpload = () => {
        setConfirmUploadModalOpen(false);
        setPendingUploadFile(null);
        setPendingUploadFiles([]);
        setPendingUploadFolderName('');
        setPendingUploadType('file');
        setTargetFolderPath('');
    };

    // Trigger folder input
    const handleUploadFolder = () => {
        handleUploadMenuClose(true); // Keep folder path for upload
        document.getElementById('raised-button-folder').click();
    };
    const formatFileSize = (size) => {
        const i = Math.floor(Math.log(size) / Math.log(1024));
        return `${(size / Math.pow(1024, i)).toFixed(2)} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`;
    };

    // Build folder tree structure for backend
    const buildFolderTreeForUpload = (files, targetFolderPath = '') => {
        const struct = {};
        files.forEach(file => {
            // Skip if file doesn't have a name
            if (!file || !file.name) {
                return;
            }
            
            let folderPath = file.webkitRelativePath || file.name;
            
            // If target folder path is specified, prepend it to the folder path
            if (targetFolderPath) {
                // Remove root folder name from webkitRelativePath if it exists
                const pathParts = folderPath.split('/');
                const relativePath = pathParts.length > 1 ? pathParts.slice(1).join('/') : folderPath;
                folderPath = relativePath ? `${targetFolderPath}/${relativePath}` : `${targetFolderPath}/${file.name}`;
            }
            
            const pathParts = folderPath.split('/');
            const fileName = pathParts[pathParts.length - 1];
            
            // Skip if fileName is empty (folder path ending with /)
            if (!fileName || fileName.trim() === '') {
                return;
            }
            
            const folderParts = pathParts.slice(0, -1);
            
            // Navigate/create folder structure
            let current = struct;
            folderParts.forEach(folderName => {
                if (!current[folderName]) {
                    current[folderName] = { folder_name: folderName, files: [], sub_folders: {} };
                }
                current = current[folderName].sub_folders;
            });
            
            // Add file to appropriate location
            if (folderParts.length === 0) {
                // Root level file
                if (!struct.files) struct.files = [];
                struct.files.push({ file_name: fileName });
            } else {
                // File in folder
                let deepestFolder = struct;
                folderParts.forEach(folderName => {
                    deepestFolder = deepestFolder[folderName];
                });
                if (!deepestFolder.files) deepestFolder.files = [];
                deepestFolder.files.push({ file_name: fileName });
            }
        });
        
        // Convert to array format
        const convertToArray = (node) => {
            if (node.folder_name) {
                return {
                    folder_name: node.folder_name,
                    files: node.files || [],
                    sub_folders: Object.values(node.sub_folders || {}).map(sub => convertToArray(sub))
                };
            }
            return null;
        };
        
        // Get root folder
        const rootKeys = Object.keys(struct).filter(key => struct[key].folder_name);
        if (rootKeys.length === 1) {
            return convertToArray(struct[rootKeys[0]]);
        } else if (struct.files && struct.files.length > 0) {
            return {
                folder_name: rootKeys[0] || "Uploaded_Folder",
                files: struct.files,
                sub_folders: rootKeys.map(key => convertToArray(struct[key]))
            };
        }
        return rootKeys.length > 0 ? convertToArray(struct[rootKeys[0]]) : null;
    };

    const handleFileUpload = async () => {
        setAddDocLoading(true);
        setUploading(true);
        setIsCloseDisabled(true);
        
        try {
            const storedData = JSON.parse(localStorage.getItem('userDetails'));
            const userid = storedData.userDetails.id;
            
            // Check if files are selected from tree structure
            if (selectedFileUrls.size > 0) {
                // Get initially selected files from backend (already selected files)
                const initiallySelectedFiles = rowData.selectedFiles || [];
                const initiallySelectedSet = new Set(initiallySelectedFiles);
                
                // Filter out files that were already selected - only send newly selected files
                const newlySelectedFiles = Array.from(selectedFileUrls).filter(
                    fileUrl => !initiallySelectedSet.has(fileUrl)
                );
                
                // If no new files selected, show message and return
                if (newlySelectedFiles.length === 0) {
                    showSnackbar('No new files selected. All selected files were already added.', 'info');
                    setAddDocLoading(false);
                    setUploading(false);
                    setIsCloseDisabled(false);
                    return;
                }
                
                // Prepare payload in the format required by backend - only newly selected files
                const payload = {
                    rfpid: id,
                    doc_type: documentType,
                    selectedFiles: newlySelectedFiles
                };
                
                const response = await axios.post(`${baseApiUrl}/dashboard/listdocumnets/add_doc`, payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                
                if (response.data.status_code === 200) {
                    // Refresh documents list to show newly added files
                    await fetchDocuments();
                    
                    // Refresh RFP data to show updated folder structure
                    fetchrfpData();
                    
                    // Clear selected files
                    setSelectedFileUrls(new Set());
                    
                    setFileUploadModalOpen(false);
                    handleFileClose();
                    showSnackbar(
                        response.data.message || `${newlySelectedFiles.length} newly selected file(s) added successfully.`, 
                        'success'
                    );
                } else {
                    showSnackbar(response.data.message || 'Failed to add selected files.', 'error');
                }
                
                setAddDocLoading(false);
                setUploading(false);
                setIsCloseDisabled(false);
                return;
            }
            
            // Check if this is a folder upload
            const isFromFolder = files.length > 0 && files.some(file => file.webkitRelativePath && file.webkitRelativePath.includes('/'));
            
            if (isFromFolder) {
                // Filter out invalid files but keep original file objects (preserve original names)
                const validFiles = files.filter(file => {
                    if (!file || !file.name) {
                        return false;
                    }
                    return true;
                });
                
                if (validFiles.length === 0) {
                    showSnackbar('No valid files to upload.', 'error');
                    setAddDocLoading(false);
                    setUploading(false);
                    setIsCloseDisabled(false);
                    return;
                }
                
                // Check for duplicate files in existing tree structure before uploading
                // Use normalized names for comparison (checkFileExistsInTree already normalizes)
                let folderTree = null;
                if (rowData.allFiles && rowData.allFiles.length > 0) {
                    folderTree = buildTreeFromFiles(rowData.allFiles, rowData.selectedFiles);
                } else if (rowData.structure) {
                    folderTree = rowData.structure;
                }
                
                // Check each file for duplicates using normalized comparison
                const duplicateFiles = [];
                validFiles.forEach(file => {
                    if (file && file.name) {
                        // checkFileExistsInTree already normalizes names for comparison
                        // So we can pass original file name - it will be normalized internally
                        if (folderTree && checkFileExistsInTree(folderTree, file.name)) {
                            duplicateFiles.push(file.name);
                        }
                    }
                });
                
                if (duplicateFiles.length > 0) {
                    const fileList = duplicateFiles.join(', ');
                    showSnackbar(
                        `File(s) already exist in the tree structure: ${fileList}. Please use different file names.`, 
                        'error'
                    );
                    setAddDocLoading(false);
                    setUploading(false);
                    setIsCloseDisabled(false);
                    return;
                }
                
                // Build folder structure - pass target folder path to prepend it
                // Use original files for building structure (preserve original names)
                const uploadFolderTree = buildFolderTreeForUpload(validFiles, targetFolderPath);
                
                // Extract path from first file
                const firstFilePath = validFiles[0]?.webkitRelativePath || validFiles[0]?.name || "";
                const pathParts = firstFilePath.split('/');
                let pathValue = pathParts.length > 1 ? pathParts.slice(0, -1).join('/') : pathParts[0] || "";
                
                // If target folder path is specified, prepend it to the path
                if (targetFolderPath && pathValue) {
                    pathValue = `${targetFolderPath}/${pathValue}`;
                } else if (targetFolderPath && !pathValue) {
                    pathValue = targetFolderPath;
                }
                
                // Build FormData according to backend format
                const formData = new FormData();
                formData.append('user_id', userid);
                formData.append('rfp_id', id);
                formData.append('folder_structure', JSON.stringify(uploadFolderTree));
                
                // Add all files (can be multiple) with ORIGINAL names (not sanitized)
                validFiles.forEach(file => {
                    if (file && file.name) {
                        formData.append('all_files', file, file.name);
                    }
                });
                
                formData.append('path', pathValue);
                formData.append('mode', 'folder');
                
                // Use the new endpoint
                const response = await axios.post(`${baseApiUrl}/listdocumnets/upload_file`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'accept': 'application/json'
                    }
                });
                
                if (response.data.status_code === 200) {
                    // Add uploaded files directly to tree structure without refreshing
                    let newFileUrls = [];
                    
                    // Check multiple possible response formats
                    if (response.data.file_urls && Array.isArray(response.data.file_urls)) {
                        newFileUrls = response.data.file_urls.filter(url => url && !url.endsWith('/'));
                    } else if (response.data.file_url && typeof response.data.file_url === 'string') {
                        newFileUrls = [response.data.file_url];
                    } else if (response.data.details && response.data.details.file_url) {
                        newFileUrls = [response.data.details.file_url];
                    } else if (response.data.results && Array.isArray(response.data.results)) {
                        // Extract URLs from results array
                        response.data.results.forEach(result => {
                            if (result.file_url) newFileUrls.push(result.file_url);
                            if (result.doc_url) newFileUrls.push(result.doc_url);
                        });
                    }
                    
                    // Update rowData with new file URLs
                    if (newFileUrls.length > 0) {
                        setRowData(prevData => {
                            const updatedAllFiles = [...(prevData.allFiles || []), ...newFileUrls];
                            
                            // Rebuild tree structure with new files
                            const updatedTree = buildTreeFromFiles(updatedAllFiles, prevData.selectedFiles || []);
                            
                            return {
                                ...prevData,
                                allFiles: updatedAllFiles,
                                structure: updatedTree || prevData.structure,
                                mode: 'folder' // Always set mode to folder when files are uploaded
                            };
                        });
                        
                        // Ensure folder tree is visible
                        setShowFolderTree(true);
                        
                        // Fetch updated structure from backend to ensure consistency
                        setTimeout(() => {
                            fetchUpdatedFolderStructure(response.data);
                        }, 500);
                    }
                    
                    setTargetFolderPath(''); // Reset folder path after successful upload
                    setProgress(100);
                    showSnackbar(response.data.message || `${files.length} files uploaded successfully.`, 'success');
                    
                    // Clear files array after successful upload but keep modal open to show files
                    setFiles([]);
                    
                    // Keep modal open so user can see files in tree structure
                    // Modal will close when user clicks close button
                }
            } else {
                // Single file upload - Normal document upload (not via + button)
                // Normal single file upload - include target folder path if specified
                // Check if file exists
                if (!file || !file.base64) {
                    showSnackbar('No file selected for upload.', 'error');
                    setAddDocLoading(false);
                    setUploading(false);
                    setIsCloseDisabled(false);
                    return;
                }
                
                const payload = {
                    rfpid: id,
                    doc_name: fileName,
                    doc_type: documentType,
                    base64: file.base64,
                };
                
                // Add folder path if files are being uploaded to a specific folder
                if (targetFolderPath) {
                    payload.folder_path = targetFolderPath;
                }
                
                const res = await axios.post(`${baseApiUrl}/dashboard/listdocumnets/add_doc`, payload);
                
                if (res.data.status_code === 200) {
                    // Refresh documents list to show newly uploaded file
                    await fetchDocuments();
                    
                    // Refresh RFP data to show updated folder structure
                    fetchrfpData();
                    
                    setFileUploadModalOpen(false);
                    setTargetFolderPath(''); // Reset folder path after successful upload
                    handleFileClose();
                    setProgress(100);
                    showSnackbar('Document added successfully.', 'success');
                }
            }
        } catch (error) {
            console.error("Upload failed:", error);
            showSnackbar('Upload failed: Please try again.', 'error');
            setProgress(0);
        } finally {
            setAddDocLoading(false);
            setUploading(false);
            clearInterval(uploadTimer.current);
            setIsCloseDisabled(false);
        }
    }

    const handleCancelUpload = () => {
        cleanUp();
        setProgress(0);
        setFile(null);
        setUploadSuccess(false);
        document.getElementById('raised-button-file').value = '';
    };

    const handlePauseUpload = () => {
        setPaused(true);
        setUploading(false);
        clearInterval(uploadTimer.current);
    };

    const handleResumeUpload = () => {
        if (paused) {
            setPaused(false);
            setResumeRequested(true);
        }
    };

    useEffect(() => {
        if (resumeRequested && !uploading) {
            setResumeRequested(false);
            simulateFileUpload(file, progress);
        }
    }, [resumeRequested, file, progress, uploading, simulateFileUpload]);

    const cleanUp = () => {
        clearInterval(uploadTimer.current);
        setUploading(false);
        setPaused(false);
    };

    const handleFileOpen = () => {
        setFileUploadModalOpen(true);
        // Show folder tree if we have files to display
        if (rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0) {
            setShowFolderTree(true);
        } else if (rowData.mode === "folder" || (rowData.structure && (rowData.structure.files?.length > 0 || rowData.structure.sub_folders?.length > 0))) {
            setShowFolderTree(true);
        }
    };

    const handleFileClose = () => {
        cleanUp();
        setFile(null);
        setFiles([]); // Reset files array
        setFileName('');
        setDocumentType('');
        setProgress(0);
        setUploadSuccess(false);
        setLoading(false);
        document.getElementById('raised-button-file').value = '';
        document.getElementById('raised-button-folder').value = '';
        setFileUploadModalOpen(false);
        setShowFolderTree(false);
        setAddedFiles([]); // Reset added files when modal closes
        setAddedFilesData(new Map()); // Reset file data map
        setUploadMenuAnchor(null); // Close upload menu
        setEditingFile(null); // Reset editing state
        setEditingFileName(''); // Reset editing file name
        setTargetFolderPath(''); // Reset target folder path when modal closes
    };

    // Load folder paths from localStorage when modal opens
    useEffect(() => {
        if (fileUploadModalOpen) {
            try {
                const storedPaths = localStorage.getItem('lastFolderUploadPaths');
                if (storedPaths) {
                    const paths = JSON.parse(storedPaths);
                    setFolderPaths(paths);
                    setShowFolderTree(paths.length > 0);
                } else {
                    setFolderPaths([]);
                    setShowFolderTree(false);
                }
            } catch (e) {
                setFolderPaths([]);
                setShowFolderTree(false);
            }
        }
    }, [fileUploadModalOpen]);

    // Update document name field with selected file names from tree
    useEffect(() => {
        if (selectedFileUrls.size > 0) {
            // Extract file names from selected URLs
            const fileNames = Array.from(selectedFileUrls)
                .map(url => getFileNameFromUrl(url))
                .filter(name => name && name.trim() !== '') // Filter out empty names
                .join('\n'); // Join with newline to show one file per line
            
            setFileName(fileNames);
        } else if (fileUploadModalOpen && !file && files.length === 0) {
            // Clear fileName when no files are selected and no files are being uploaded
            setFileName('');
        }
    }, [selectedFileUrls, fileUploadModalOpen, file, files]);

    // Build folder structure from paths
    const buildFolderStructure = (paths) => {
        const structure = {};
        paths.forEach((path) => {
            const pathParts = path.split('/');
            let current = structure;
            let currentPath = '';
            
            for (let i = 0; i < pathParts.length - 1; i++) {
                const folderName = pathParts[i];
                currentPath = currentPath ? `${currentPath}/${folderName}` : folderName;
                
                if (!current[folderName]) {
                    current[folderName] = { type: 'folder', children: {}, absolutePath: currentPath };
                }
                current = current[folderName].children;
            }
            
            const fileName = pathParts[pathParts.length - 1];
            current[fileName] = { type: 'file', path };
        });
        return structure;
    };

    // Get all paths (original + added files) for display
    const getAllPaths = () => {
        return [...folderPaths, ...addedFiles];
    };

    // Handle adding file to specific folder
    const handleAddFileToFolder = async (folderPath) => {
        
        // Build tree structure first to check for duplicates
        let folderTree = null;
        if (rowData.mode === "folder") {
            if (rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0) {
                folderTree = buildTreeFromFiles(rowData.allFiles, rowData.selectedFiles);
            } else if (rowData.structure && (rowData.structure.files?.length > 0 || rowData.structure.sub_folders?.length > 0)) {
                folderTree = rowData.structure;
            }
            
            // Merge already added files into tree for checking
            if (folderTree && addedFiles.length > 0) {
                folderTree = mergeAddedFilesIntoTree(folderTree, addedFiles, addedFilesData);
            }
        }
        
        // Create a hidden file input for this specific folder
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.doc,.docx,.xls,.xlsx,.csv';
        input.style.display = 'none';
        input.multiple = true;
        
        input.onchange = async (e) => {
            const files = Array.from(e.target.files);
            if (files.length > 0) {
                // Check for duplicates first before processing
                const duplicateFiles = [];
                for (const file of files) {
                    const fileName = file.name;
                    if (folderTree && checkFileExistsInTree(folderTree, fileName)) {
                        duplicateFiles.push(fileName);
                    }
                }
                
                // If duplicates found, show error and prevent upload
                if (duplicateFiles.length > 0) {
                    const duplicateList = duplicateFiles.join(', ');
                    showSnackbar(`The following file(s) already exist in the folder structure: ${duplicateList}. Please remove them or rename them before uploading.`, 'error');
                    input.value = null; // Clear file input
                    return;
                }
                
                const newFiles = [];
                
                for (const file of files) {
                    const fileName = file.name;
                    // Ensure folderPath is used exactly as provided - this is the target folder
                    const fullPath = `${folderPath}/${fileName}`;
                    
                    // Double check in addedFiles as well (for files being added in same session)
                    const fileExistsInAdded = addedFiles.some(path => {
                        const pathParts = path.split('/');
                        const existingFileName = pathParts[pathParts.length - 1];
                        return existingFileName === fileName;
                    });
                    
                    if (!fileExistsInAdded) {
                        // Store file as blob for folder uploads (no base64 conversion)
                        try {
                            const readableSize = formatFileSize(file.size);
                            
                            newFiles.push({
                                path: fullPath,
                                name: fileName,
                                file: file, // Store file object directly
                                size: file.size,
                                readableSize: readableSize
                            });
                        } catch (error) {
                            console.error('Error processing file:', error);
                            showSnackbar(`Error processing file: ${fileName}`, 'error');
                        }
                    } else {
                        showSnackbar(`File "${fileName}" already exists in another folder`, 'warning');
                    }
                }
                
                if (newFiles.length > 0) {
                    // Add new files to the addedFiles state (don't modify folderPaths)
                    setAddedFiles(prev => {
                        return [...prev, ...newFiles.map(f => f.path)];
                    });
                    
                    // Store file data in Map (as blob, not base64)
                    setAddedFilesData(prev => {
                        const newMap = new Map(prev);
                        newFiles.forEach(fileData => {
                            newMap.set(fileData.path, {
                                name: fileData.name,
                                file: fileData.file, // Store file object directly, not base64
                                size: fileData.size,
                                readableSize: fileData.readableSize
                            });
                        });
                        return newMap;
                    });
                    
                    // Ensure folder tree is shown
                    setShowFolderTree(true);
                    
                    // If no file is currently selected, set the first one as selected
                    if (!fileName && newFiles.length > 0) {
                        const firstFile = newFiles[0];
                        setFileName(firstFile.name);
                        setFile({ 
                            name: firstFile.name, 
                            path: firstFile.path,
                            file: firstFile.file, // Store file object, not base64
                            readableSize: firstFile.readableSize
                        });
                    }
                    
                    showSnackbar(`${newFiles.length} file(s) added to folder`, 'success');
                }
            }
        };
        
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    };

    // Render tree structure
    const renderTree = (structure, level = 0, parentPath = '') => {
        const items = [];
        // Render files first (so they sit directly under their folder), then subfolders
        const entries = Object.entries(structure).sort((a, b) => {
            const aIsFolder = a[1]?.type === 'folder';
            const bIsFolder = b[1]?.type === 'folder';
            if (aIsFolder !== bIsFolder) return aIsFolder ? 1 : -1;
            return a[0].localeCompare(b[0]);
        });
        
        entries.forEach(([name, item], idx) => {
            const isLast = idx === entries.length - 1;
            const indent = '│  '.repeat(level);
            const connector = isLast ? '└── ' : '├── ';
            const fullPath = item.absolutePath || (parentPath ? `${parentPath}/${name}` : name);
            
            if (item.type === 'folder') {
                items.push(
                    <Box key={`folder-${name}-${level}-${idx}`} sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        mb: 0.5,
                        fontFamily: 'Arial, sans-serif',
                        fontSize: '12px',
                        overflow: 'hidden'
                    }}>
                        <Typography sx={{ 
                            color: '#2196f3',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            whiteSpace: 'pre',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1,
                            minWidth: 0,
                            textAlign: 'left'
                        }}
                        title={`${indent}${connector}📁 ${name}`}
                        >
                            {indent}{connector}📁 {name}
                        </Typography>
                        <Box
                            onClick={(e) => {
                                e.stopPropagation();
                                // Use the absolute fullPath for this folder
                                const targetFolder = (item && item.absolutePath) ? item.absolutePath : fullPath;
                                handleAddFileToFolder(targetFolder);
                            }}
                            sx={{
                                marginLeft: '8px',
                                width: '19px',
                                height: '19px',
                                borderRadius: '4px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '12px',
                                fontWeight: '600',
                                boxShadow: '0 1px 4px rgba(102, 126, 234, 0.3)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                position: 'relative',
                                flexShrink: 0,
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '8px',
                                    height: '1.5px',
                                    backgroundColor: 'white',
                                    borderRadius: '1px',
                                },
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '1.5px',
                                    height: '8px',
                                    backgroundColor: 'white',
                                    borderRadius: '1px',
                                }
                            }}
                            title={`Add file to ${name} folder`}
                        >
                        </Box>
                    </Box>
                );
                
                // Render folder contents
                items.push(...renderTree(item.children, level + 1, fullPath));
            } else {
                // Check if file data exists in addedFilesData
                const fileData = addedFilesData.get(item.path);
                
                items.push(
                    <Box 
                        key={`file-${name}-${level}-${idx}`}
                        onClick={() => {
                            setFileName(name);
                            if (fileData) {
                                setFile({ 
                                    name: fileData.name,
                                    path: item.path,
                                    base64: fileData.base64,
                                    readableSize: fileData.readableSize
                                });
                            } else {
                                setFile({ name, path: item.path });
                            }
                        }}
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            mb: 0.5,
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: '#f0f0f0' },
                            backgroundColor: fileName === name ? '#e3f2fd' : 'transparent'
                        }}
                    >
                        <Typography sx={{ 
                            color: '#333',
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '12px',
                            whiteSpace: 'pre',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1,
                            minWidth: 0,
                            textAlign: 'left'
                        }}
                        title={`${indent}${connector}📄 ${name}`}
                        >
                            {indent}{connector}📄 {name}
                        </Typography>
                    </Box>
                );
            }
        });
        
        return items;
    };


    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = error => reject(error);
        });
    };


    const handleFileNameChange = (event) => {
        setFileName(event.target.value);
    };

    const handleNotificationsOpen = () => {
        setNotificationsOpen(true);
        setUnreadCount(0);
    };

    const handleNotificationsClose = () => {
        setNotificationsOpen(false);
    };

    const handleSaveComment = () => {
        const storedData = JSON.parse(localStorage.getItem('userDetails'));
        const userId = storedData.userDetails.id;
        const commentData = {
            userid: userId,
            comments: comment,
            rfpid: id,
            status: ''
        }
        axios.post(`${baseApiUrl}/dashboard/addrfpcomment`, commentData)
            .then(response => {
                fetchrfpData();
                setComment('');
                showSnackbar('comment added successfully.', 'success');
            })
            .catch(error => {
                console.error('Error saving comment:', error.response.data);
            });
    }

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('userDetails'));
        const userId = storedData.userDetails.id;
        axios
            .get(`${baseApiUrl}/notification/getlist?rfpid=${id}&userid=${userId}`)
            .then((response) => {
                const data = response.data;
                const newNotifications = [
                    { type: 'Conference Due', text: data.conference_notify, read: false },
                    { type: 'RFP Questions Due', text: data.questionnaire_notify, read: false },
                    { type: 'Proposal Due', text: data.submission_notify, read: false },
                ];

                setUnreadCount(newNotifications.length);
            })
            .catch((error) => {
                console.error('Error fetching notifications:', error);
            });
    }, []);



    return (
        <Container fluid className='ps-3 mt-2 rfpDtailsContainer '>
            {loading && (
                <Box
                    className="circular-progress"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 1000,
                    }}
                >
                    <CircularProgress className=" text-primary" />
                </Box>
            )}
            <div >
                <Card className='rounded-3'>
                    <Box style={{ paddingBottom: '16px' }}>
                        <div style={{ padding: '16px 0' }}>
                            <Row className="mb-2 align-items-center mx-1">
                                <Col xs={12} sm={6} md={6}>
                                    <Typography className='fontstylee MicroSoftRFPDetails_heading' sx={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                        {rowData.rfp_issuer || rowData.file_name }
                                    </Typography>
                                </Col>
                                <Col xs={12} sm={6} md={6} className=" d-flex justify-content-end">
                                    <Button className='border-primary text-primary text-capitalize rounded-2 '
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleBackdetails}
                                    >
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                        <Container fluid>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '10px',
                                    padding: '16px',
                                    position: 'relative',
                                    marginTop: "6px"
                                }}
                                className='mb-5'
                            >
                                <Typography
                                    sx={{
                                        position: 'absolute',
                                        top: '-12px',
                                        left: '20px',
                                        background: '#fff',
                                        padding: '0 8px',
                                        fontSize: '16px'
                                    }}
                                    className='fontstylee'
                                >
                                    RFP Details
                                </Typography>
                                <Row className=' pb-4 pt-2'>
                                    <Col lg={3} md={4} sm={6} >
                                        <Typography className='fontstylee py-3 search-bar' >First Review</Typography>
                                                      <Typography>
                                                           {rowData.first_review ? `${rowData.first_review} (${rowData.first_review_date_timezone || "IST"})` : "NA"}
                                                       </Typography>


                                    </Col>
                                    <Col lg={3} md={4} sm={6}>
                                        <Typography className='fontstylee py-3'>RFP Issuer</Typography>
                                        <Typography>{rowData.rfp_issuer ||"NA"}</Typography>
                                    </Col>
                                    <Col lg={3} md={4} sm={6}>
                                        <Typography className='fontstylee py-3'>Rfp Type</Typography>
                                        <Typography>{rowData.rfp_type ||"NA"}</Typography>
                                    </Col>
                                    <Col lg={3} md={12} sm={6}>
                                        <Typography className='fontstylee py-3'>Location</Typography>
                                        <Typography>{rowData.location ||"NA"}</Typography>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col lg={3} md={6} sm={3}>
                                        <Typography className='fontstylee py-3'>Budget Range($)</Typography>
                                        <Typography>{rowData.budget_range ||"NA"}</Typography>
                                    </Col>
                                    <Col lg={3} md={6} sm={3}>
                                        <Typography className='fontstylee py-3'>Expected Timeline(In Months)</Typography>
                                        <Typography>{rowData.expected_timeline||"NA"}</Typography>
                                    </Col>
                                    <Col xs={12} lg={4} md={12} sm={3} >
                                        <Typography className='fontstylee py-3' >Website</Typography>

                                        <Typography sx={{
                                            wordBreak: 'break-all'
                                        }} >      <a href={rowData.website} target="_blank" rel="noopener noreferrer">
                                                {rowData.website||"NA"}
                                            </a></Typography>

                                    </Col>
                                </Row>
                            </Box>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '10px',
                                    padding: '16px',
                                    position: 'relative'
                                }}
                                className='mb-5'
                            >
                                <Typography
                                    sx={{
                                        position: 'absolute',
                                        top: '-12px',
                                        left: '20px',
                                        background: '#fff',
                                        padding: '0 8px',
                                        fontSize: '16px'
                                    }}
                                    className='fontstylee microsoftrfpdetails'
                                >
                                    Point of Contact Details
                                </Typography>
                                <Row>
                                    <Col lg={4} md={5} sm={3}>
                                        <Typography className='fontstylee py-3'>Name</Typography>
                                        <Typography className='text-capitalize'>{rowData.contact_name||"NA"}</Typography>
                                    </Col>
                                    <Col lg={5} md={5} sm={3}>
                                        <Typography className='fontstylee py-3'>Email</Typography>
                                        <Typography sx={{
                                            wordBreak: 'break-all'
                                        }}>{rowData.contact_email||"NA"}</Typography>
                                    </Col>
                                </Row>
                            </Box>
                            <Box
                                sx={{
                                    border: '1px solid #ccc',
                                    borderRadius: '10px',
                                    padding: '16px',
                                    marginBottom: '16px',
                                    position: 'relative'
                                }}
                            >
                                <Typography
                                    className='fontstylee'
                                    sx={{
                                        position: 'absolute',
                                        top: '-12px',
                                        left: '20px',
                                        background: '#fff',
                                        padding: '0 8px',
                                        fontSize: '16px'

                                    }}
                                >
                                    Submission Details
                                </Typography>
                                <Row className='pb-4'>
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Conference Date</Typography>
                                        <Typography>
                                            {rowData.conference_date ? `${rowData.conference_date} (${rowData.conference_date_timezone || "IST"})` : "NA"}
                                         </Typography>
                                    </Col>
                                    
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Questionnaire Date</Typography>
                                        <Typography>
                                            {rowData.questionnaire_date ? `${rowData.questionnaire_date} (${rowData.questionnaire_date_timezone || "IST"})` : "NA"}
                                        </Typography>
                                    </Col>
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Status</Typography>
                                        <Typography>{statusMapping[rowData.status] ||"NA"}</Typography>
                                    </Col>
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Submission Mode</Typography>
                                        <Typography>{rowData.submission_mode||"NA"}</Typography>
                                    </Col>
                                </Row>
                                <Row>
        
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Submission Date</Typography>
                                        <Typography>
                                            {rowData.submission_date ? `${rowData.submission_date} (${rowData.submission_date_timezone || "IST"})` : "NA"}
                                            </Typography>
                                    </Col>
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Internal POC Name</Typography>
                                        <Typography className='text-capitalize'>{rowData.internal_poc_name ||"NA"}</Typography>
                                    </Col>
                                    <Col lg={3} md={6} sm={6}>
                                        <Typography className='fontstylee py-3'>Additional Status</Typography>
                                        <Typography sx={{
                                            wordBreak: 'break-all'
                                        }}>{rowData.additional_status ||"NA"}</Typography>
                                    </Col>
                                </Row>
                                <Row>
                                <Col lg={12} md={12} sm={12}>
                                        <Typography className='fontstylee py-3'>Conference Information</Typography>
                                        <Typography>{rowData.conference_information ||"NA"}</Typography>
                                    </Col>
                                </Row>
                            </Box>
                           
                            <Box>

                                <>
                                    <Row className='py-3 g-2 rfpdetailscn'>
                                        <Col xs={12} sm={12} lg={3} md={5} className='d-flex align-items-center ps-2 rfpdetailscnn commentsrfpd '>
                                            <img src={CommentsImage} alt='commentsImage' className='me-2 iconheight' />
                                            <Typography
                                                variant='h5'
                                                onClick={handleOpen}
                                                className='fontstylee previewCommentText text-primary'
                                            >
                                                Comments({Commentcount.length})
                                            </Typography>
                                        </Col>

                                        <Col xs={12} sm={12} lg={2} md={4} className='d-flex align-items-center rfpdetailscnbn '>
                                            <div className='badgenotificationmd'>
                                                <Badge
                                                    color="error"
                                                    badgeContent={unreadCount}
                                                    onClick={handleNotificationsOpen}
                                                    className="cursor-pointer"
                                                    sx={{
                                                        '& .MuiBadge-badge': { backgroundColor: unreadCount > 0 ? 'red' : 'blue' }
                                                    }}
                                                >
                                                    <NotificationsIcon fontSize="large" className='text-primary notificationicon' />
                                                </Badge>
                                            </div>

                                            <Typography
                                                variant='h5'
                                                onClick={handleNotificationsOpen}
                                                className='fontstylee previewRemarkText text-primary cursor-pointer'
                                            >
                                                Notifications
                                            </Typography>
                                        </Col>

                                        <Col lg={7} md={3} className='d-flex justify-content-end pe-2'>
                                            <Button
                                                variant="contained"
                                                className='bg-primary text-capitalize rounded-2 docUpload_editbtn '
                                                onClick={handleEditPage}
                                            >
                                                Edit
                                            </Button>
                                        </Col>
                                    </Row>

                                    <NotificationsPanel open={isNotificationsOpen} onClose={handleNotificationsClose} rfpId={id} />
                                </>
                            </Box>
                        </Container>
                    </Box>
                </Card>

                <Card className='mt-3' sx={{ height: 'auto' }}>
                    <CardContent sx={{ height: '100%' }}>
                        <Row className="mb-2 align-items-center list-documents">
                            <Col xs={12} sm={6} md={6}>
                                <Typography className='fontstylee MicroSoftRFPDetails_heading'>
                                    List of Documents
                                </Typography>
                            </Col>
                            <Col xs={12} sm={6} md={6} className=" d-flex justify-content-end">
                                <Button style={{ marginRight: '10px' }} className='bg-primary text-capitalize rounded-2 '
                                    variant="contained"
                                    color="primary"
                                    onClick={handleFileOpen}
                                >
                                    Add
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleDocument}
                                    color="primary"
                                    disabled={!isUploadAvailable}
                                    className="text-capitalize rounded-2"
                                    sx={{
                                        backgroundColor: isUploadAvailable ? '#0d6efd' : '#fff',
                                        color: '#fff',
                                        cursor: isUploadAvailable ? 'pointer' : 'not-allowed',
                                        '&:hover': {
                                            backgroundColor: isUploadAvailable ? '#0d6efd' : '#fff',
                                        }
                                    }}
                                >
                                    Response Document
                                </Button>

                            </Col>
                        </Row>
                        <Card>
                                <TableContainer sx={{
                                    width: '100%',
                                    height: 'auto',
                                    overflow: 'auto',
                                    '&::-webkit-scrollbar': {
                                        height: '3px',
                                        width: '3px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: '#888',
                                        borderRadius: '6px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        backgroundColor: '#555',
                                        cursor: 'pointer',
                                    },
                                }}>
                                    <Table aria-label="simple table" stickyHeader sx={{ width: '100%' }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Document Name</Typography></TableCell>
                                                <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Document Type</Typography></TableCell>
                                                <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Uploaded Date</Typography></TableCell>
                                                <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}><Typography className='fontstylee'>Actions</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody className='position-relative'>

                                            {documents.length === 0 && !loading ? (
                                                <Box
                                                    sx={{

                                                        position: 'absolute',
                                                        top: 100,
                                                        left: 450,
                                                    }}
                                                >
                                                    <Typography variant="h6">No Records Found</Typography>
                                                </Box>
                                            ) : (

                                                documents.map((doc, index) => (

                                                    <TableRow key={index}>
                                                        <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                                            <Typography
                                                                onClick={() => handleDocumentClick(doc)}
                                                                className={`fontstylee documentname ${doc.doc_type === "RFP" ? "text-primary" : ""}`}
                                                                sx={{
                                                                    cursor: doc.doc_type === "RFP" ? "pointer" : "default",
                                                                    color: doc.doc_type === "RFP" ? "primary.main" : "black",
                                                                    opacity: 1,
                                                                    textDecoration: doc.doc_type === "RFP" ? "underline" : "none",
                                                                    "&:hover": {
                                                                        color: doc.doc_type === "RFP" ? "primary.main" : "black"
                                                                    }
                                                                }}
                                                            >
                                                                {doc.doc_name}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>{doc.doc_type}</TableCell>
                                                        <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>{doc.uploaded_on}</TableCell>
                                                        <TableCell sx={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                                        {(() => {
                                                            // Get the document URL - check both doc_url and file_url, and try to find from allFiles
                                                            const docUrl = doc.doc_url || doc.file_url || findDocumentUrl(doc.doc_name);
                                                            const hasValidUrl = docUrl && docUrl !== 'null' && docUrl !== 'undefined' && docUrl.trim() !== '';
                                                            
                                                            return (
                                                                <Tooltip title={!hasValidUrl ? 'Document URL not available' : 'View Document'} arrow>
                                                                    <IconButton 
                                                                        onClick={() => pdfOpenDeatils(doc.doc_url || doc.file_url, doc)}
                                                                        disabled={!hasValidUrl}
                                                                    >
                                                                        <img 
                                                                            src={EYEIMG} 
                                                                            width="31px" 
                                                                            height="31px" 
                                                                            alt="eyeimg" 
                                                                            style={{ 
                                                                                backgroundColor: '#D9EAFF', 
                                                                                borderRadius: '38%', 
                                                                                padding: '7px',
                                                                                opacity: !hasValidUrl ? 0.5 : 1
                                                                            }} 
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            );
                                                        })()}
                                                            {doc.main_rfp === false && (
                                                                <Tooltip title="Delete Document" arrow>
                                                                <IconButton onClick={() => handleOpenDeleteModal(doc)}>
                                                                    <img src={Trash_Empty} width="31px" height="31px" alt="trshimg" style={{ backgroundColor: '#FCD9D9', borderRadius: '38%', padding: '7px' }} />
                                                                </IconButton>
                                                                 </Tooltip>
                                                            )}
                                                         <Tooltip title={doc.doc_type === "RFP" ? "Extract Document" : "Only RFP documents can be extracted"} arrow>
                                                            <IconButton 
                                                                onClick={() => handleDocumentClick(doc)}
                                                                disabled={doc.doc_type !== "RFP"}
                                                                sx={{
                                                                    opacity: doc.doc_type === "RFP" ? 1 : 0.5,
                                                                    cursor: doc.doc_type === "RFP" ? "pointer" : "default"
                                                                }}
                                                            >
                                                                <img src={ExtractIMG} width="31px" height="31px" alt="extractimg" style={{ backgroundColor: '#DCF1E4', borderRadius: '38%', padding: '7px' }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                    </CardContent>
                </Card>
                <div className='mt-3'>
                        <Card className="mt-3" ref={microsoftRfpRef}>
                            <MicrosoftRFP
                                document={selectedDocument}
                                documentResponse={docResponse}
                                onBackButtonClick={handleBackButtonClick}
                                id={specDocId}
                                rfpid={id}
                            />
                        </Card>
                </div>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"

                >
                    <FormControl fullWidth margin="normal" className="inputfields">
                        <Box className="commentsboxeditrfp" sx={style}>

                            <Box display="flex" justifyContent="space-between" alignItems="baseline" >
                                <Typography gutterBottom className='commentsText inputfields'>
                                    Comments
                                </Typography>
                                <CloseIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                            </Box>
                            <Divider style={{ borderColor: '#adadad' }} />
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} className='addCommentText'>
                                Add Comments
                            </Typography>
                            <TextField
                                fullWidth
                                label="Comment"
                                variant="outlined"
                                className=' mb-2 rounded-5 mt-3'
                                multiline
                                rows={2}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '16px',
                                    },
                                }}
                            />
                            <Button variant="contained" className="mb-3 float-end bg-primary rounded-5 " onClick={handleSaveComment}>
                                Save
                            </Button>
                            <Typography className='mt-4 fs-6' >Previous Comment list</Typography>
                            <TableContainer component={Paper} sx={{
                                maxHeight: '300px',
                                overflowY: 'auto',
                                borderColor: 'ActiveBorder',
                                borderRadius: '12px',
                                marginTop: '15px'
                            }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" className='remarkstext'>Comment</TableCell>
                                            <TableCell align="left" className='remarkstext'>Commented Date</TableCell>
                                            <TableCell align="left" className='remarkstext'>Comment By</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Commentcount.map((comment, index) => (
                                            <TableRow key={comment.id}>
                                                <TableCell align="left">{comment.comments}</TableCell>
                                                <TableCell align="left">{comment.comment_date}</TableCell>
                                                <TableCell align="left">{comment.comment_by}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </FormControl>
                </Modal>

                <Modal open={fileUploadModalOpen} onClose={handleFileClose} aria-labelledby="modal-title" aria-describedby="modal-description">
                    <Box sx={{ ...styled, width: showFolderTree ? '700px' : '550px', maxHeight: '90vh', overflowY: 'auto' }} className='docuploadModal'>
                        {addDocLoading && (
                            <Box
                                className="circular-progress"
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    zIndex: 1000,
                                }}
                            >
                                <CircularProgress className=" text-primary" />
                            </Box>
                        )}

                        <IconButton
                            aria-label="close"
                            onClick={handleFileClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 5,
                                color: (theme) => theme.palette.grey[500],
                            }}
                            disabled={isCloseDisabled}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" component="h2" textAlign="left" className='fontstyleeb fs-6 pb-1' sx={{ marginTop: '-13px' }}>
                            Add New Document
                        </Typography>
                        <Divider />
                        <Row>
                            <Col lg={7} sm={6} xs={6}>
                                <FormControl fullWidth margin="normal" className='inputFields inputfields'>
                                    <Typography className='docName' sx={{ textDecoration: 'underline' }}>List of Documents</Typography>
                                    {selectedFileUrls.size > 0 ? (() => {
                                        const fileNames = Array.from(selectedFileUrls)
                                            .map(url => getFileNameFromUrl(url))
                                            .filter(name => name && name.trim() !== '');
                                        
                                        return (
                                            <Paper 
                                                variant="elevation"
                                                elevation={0}
                                                sx={{
                                                    borderRadius: '13px',
                                                    height: '56px',
                                                    overflow: 'hidden',
                                                    border: 'none',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <List 
                                                    dense 
                                                    sx={{ 
                                                        py: 0,
                                                        overflowY: 'auto',
                                                        overflowX: 'hidden',
                                                        flex: 1,
                                                        '&::-webkit-scrollbar': {
                                                            width: '6px',
                                                        },
                                                        '&::-webkit-scrollbar-track': {
                                                            background: 'transparent',
                                                        },
                                                        '&::-webkit-scrollbar-thumb': {
                                                            background: 'rgba(0, 0, 0, 0.2)',
                                                            borderRadius: '3px',
                                                            '&:hover': {
                                                                background: 'rgba(0, 0, 0, 0.3)',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    {fileNames.map((name, index) => (
                                                        <ListItem 
                                                            key={index}
                                                            sx={{
                                                                borderBottom: 'none',
                                                                py: 0,
                                                                minHeight: '24px',
                                                            }}
                                                        >
                                                            <ListItemText 
                                                                primary={name}
                                                                primaryTypographyProps={{
                                                                    sx: {
                                                                        fontSize: '0.875rem',
                                                                        color: 'text.primary',
                                                                        whiteSpace: 'nowrap',
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        margin: 0,
                                                                    }
                                                                }}
                                                            />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Paper>
                                        );
                                    })() : (
                                        <TextField
                                            placeholder="Document Name"
                                            name="DocName"
                                            className='inputFields'
                                            value={fileName}
                                            onChange={handleFileNameChange}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '13px',
                                                },
                                            }}
                                        />
                                    )}
                                </FormControl>
                            </Col>
                            <Col lg={5} sm={6} xs={6}>
                                <FormControl fullWidth margin="normal" className='inputFields inputfields'>
                                    <Typography className='docName'>Document Type</Typography>
                                    <Select
                                        value={documentType}
                                        onChange={(e) => setDocumentType(e.target.value)}
                                        name="submissionMode"
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '10px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderRadius: '10px',
                                            },
                                            '& .MuiSelect-icon': {
                                                color: 'blue',
                                            },
                                        }}
                                    >
                                        <MenuItem value="Addendum">Addendum</MenuItem>
                                        <MenuItem value="Support">Support</MenuItem>
                                        <MenuItem value="Final/Response">Final/Response</MenuItem>
                                        {rowData?.is_upload_rfp === false && <MenuItem value="RFP">RFP</MenuItem>}


                                    </Select>
                                </FormControl>
                            </Col>
                        </Row>
                        
                        {/* Show folder structure - prefer building from allFiles, fallback to structure key */}
                        {(() => {
                            // Try building from allFiles first, then fallback to structure key
                            let folderTree = null;
                            
                            // Show tree if mode is folder OR if we have files to display
                            const shouldShowTree = rowData.mode === "folder" || (rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0);
                            
                            if (shouldShowTree) {
                                if (rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0) {
                                    // Build tree from allFiles URLs
                                    folderTree = buildTreeFromFiles(rowData.allFiles, rowData.selectedFiles);
                                } else if (rowData.structure && (rowData.structure.files?.length > 0 || rowData.structure.sub_folders?.length > 0)) {
                                    // Fallback to structure key if allFiles is not available
                                    folderTree = rowData.structure;
                                }
                                
                                // Merge newly added files into the tree structure
                                if (folderTree && addedFiles.length > 0) {
                                    folderTree = mergeAddedFilesIntoTree(folderTree, addedFiles, addedFilesData);
                                }
                                
                                // If folderTree is null but we have allFiles, create a root structure
                                if (!folderTree && rowData.allFiles && Array.isArray(rowData.allFiles) && rowData.allFiles.length > 0) {
                                    folderTree = {
                                        folder_name: rowData.folder_name || 'Root',
                                        files: rowData.allFiles.map(url => ({
                                            file_name: getFileNameFromUrl(url),
                                            file_url: url,
                                            is_selected: rowData.selectedFiles?.includes(url) || false
                                        })),
                                        sub_folders: []
                                    };
                                }
                            }
                            
                            return folderTree && (folderTree.files?.length > 0 || folderTree.sub_folders?.length > 0) ? (
                                <>
                                    <Box
                                        sx={{
                                            backgroundColor: 'rgba(215, 233, 245)',
                                            border: '1px dashed blue',
                                            borderRadius: '5px',
                                            textAlign: 'center',
                                            p: 4,
                                            mt: 1,
                                            mb: 2,
                                            position: 'relative',
                                            width: '100%',
                                        }}
                                        className='docuploadBox'
                                    >
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center', color: '#1976d2' }}>
                                            Folder Structure:
                                        </Typography>
                                        <Box sx={{ 
                                            overflowY: 'auto',
                                            border: '1px solid #e0e0e0',
                                            borderRadius: '4px',
                                            padding: '16px',
                                            backgroundColor: '#ffffff',
                                            maxHeight: '300px',
                                            fontFamily: 'Arial, sans-serif',
                                            textAlign: 'left'
                                        }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                                <Typography sx={{ 
                                                    color: '#2196f3',
                                                    fontFamily: 'Arial, sans-serif',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    📁 {folderTree.folder_name || rowData.folder_name || 'Root'}
                                                </Typography>
                                                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => handleUploadMenuOpen(e, true, folderTree.folder_name || rowData.folder_name || 'Root')}
                                                        sx={{
                                                            padding: '2px',
                                                            marginLeft: '8px',
                                                            color: '#1976d2',
                                                            '&:hover': {
                                                                backgroundColor: '#e3f2fd'
                                                            }
                                                        }}
                                                        title="Upload files or folder"
                                                    >
                                                        <AddIcon fontSize="small" />
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={uploadMenuAnchor}
                                                        open={Boolean(uploadMenuAnchor)}
                                                        onClose={handleUploadMenuClose}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        }}
                                                    >
                                                        <MenuItem onClick={handleUploadFile}>
                                                            📄 Upload File
                                                        </MenuItem>
                                                        {/* Only show Upload Folder for root folder */}
                                                        {isRootFolderMenu && (
                                                            <MenuItem onClick={handleUploadFolder}>
                                                                📁 Upload Folder
                                                            </MenuItem>
                                                        )}
                                                    </Menu>
                                                </Box>
                                            </Box>
                                            {renderFolderTree(folderTree, 0, folderTree.folder_name || rowData.folder_name || 'Root')}
                                        </Box>
                                        {/* Limit message inside blue box */}
                                        <Typography sx={{ color: '#888', fontSize: '12px', textAlign: 'center', mt: 2 }}>
                                            Limit 50MB per file PDF, DOC, DOCX, XLSX, CSV Files Only
                                        </Typography>
                                    </Box>
                                    {/* Show selected files count - outside blue box */}
                                    <Box sx={{ mt: 2, mb: 1 }}>
                                        {/* <Typography variant="body2" sx={{ color: '#666', fontSize: '12px', textAlign: 'center' }}>
                                            Selected Files: {selectedFileUrls.size} {selectedFileUrls.size > 0 ? 'file(s)' : ''}
                                        </Typography> */}
                                        {selectedFileUrls.size === 0 && files.length === 0 && (
                                            <Typography variant="body2" sx={{ color: '#ff9800', fontSize: '11px', textAlign: 'center', mt: 0.5 }}>
                                                Please select at least one file or upload files before submitting
                                            </Typography>
                                        )}
                                    </Box>
                                    {/* Submit button - outside blue box */}
                                    <Box display="flex" justifyContent="flex-end" mt={2}>
                                        <Button 
                                            color="primary" 
                                            onClick={handleFileUpload} 
                                            className='rounded-2 bg-primary text-white' 
                                            disabled={addDocLoading || (selectedFileUrls.size === 0 && files.length === 0) || !documentType}
                                            variant="contained"
                                        >
                                            {uploading ? 'Save' : 'Submit'}
                                        </Button>
                                    </Box>
                                </>
                            ) : null;
                        })() || (
                            // Show normal upload area for "Browse files" - no tree structure
                            <Box
                                sx={{
                                    backgroundColor: 'rgba(215, 233, 245)',
                                    border: '1px dashed blue',
                                    borderRadius: '5px',
                                    textAlign: 'center',
                                    p: 6,
                                    mt: 1,
                                    mb: 2,
                                    position: 'relative',
                                    width: '100%',
                                }}
                                className='docuploadBox'
                            >
                                <Box onClick={() => document.getElementById('raised-button-file').click()}>
                                    <img src={PDFICON} alt='PDFICON' width={'70px'} height={'84px'} style={{ cursor: 'pointer' }} className='addRfpdoc' />
                                </Box>

                                {!file && (
                                    <>
                                        <Typography className='dragText'>Drag and Drop your File here, or{' '}
                                            <label htmlFor="raised-button-file" style={{ color: '#007bff', cursor: 'pointer' }}>
                                                Browse Files
                                            </label>
                                        </Typography>
                                        <Typography sx={{ color: '#888', fontSize: '12px' }} className='dragText'>
                                            Limit 50MB per file  PDF, XLSX, DOCX, CSV Files Only
                                        </Typography>
                                    </>
                                )}

                                {file && (
                                    <>
                                        <Typography sx={{ fontSize: '14px', mt: 1 }} className='uploadDocName' style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                                            {(() => {
                                                const displayName = fileName || (file?.name || '');
                                                // Remove any size patterns like "(2.92 MB)", "(2.5 KB)", etc.
                                                return displayName.replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*\([0-9.]+?\s*(MB|KB|GB|TB|B)\)\s*/gi, '').trim();
                                            })()}
                                        </Typography>
                                        <Typography sx={{ color: '#888', fontSize: '12px', mt: 1 }} className='dragText'>
                                            Limit 50MB per file  PDF, XLSX, DOCX, CSV Files Only
                                        </Typography>
                                    </>
                                )}
                            </Box>
                        )}

                        {/* File input for single file upload */}
                        <input
                            accept=".pdf,.doc,.docx"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        {/* Folder input for folder upload */}
                        <input
                            accept=".pdf,.doc,.docx"
                            style={{ display: 'none' }}
                            id="raised-button-folder"
                            type="file"
                            webkitdirectory=""
                            directory=""
                            multiple
                            onChange={handleFolderChange}
                        />
                        {uploading && (
                            <Box sx={{ width: '100%' }}>
                                <div className='border border-1px solid grey p-2'>
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Box display="flex" alignItems="center">
                                            <img src={PDFICON} alt='PDFICON' width={'30px'} height={'42px'} style={{ cursor: 'pointer' }} className='pb-2 mx-1' />
                                            <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <Typography className='uploadDocName' style={{ textDecoration: 'none', textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                                                    {fileName || file.name}
                                                    {file?.readableSize || 'Size unknown'}
                                                </Typography>
                                            </div>
                                        </Box>
                                    </Box>
                                    <LinearProgress variant="determinate" value={progress} sx={{
                                        '& .MuiLinearProgress-bar': {
                                            backgroundColor: '#4caf50',
                                        },
                                        mt: 1,
                                    }} />
                                </div>
                            </Box>
                        )}
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <div>
                                {file && fileName && documentType && (
                                    <Button color="primary" onClick={handleFileUpload} className='rounded-2 bg-primary text-white' disabled={addDocLoading}>
                                          {uploading ? 'Save' : 'Submit'}
                                    </Button>
                                )}
                            </div>
                        </Box>
                    </Box>
                </Modal>

                <Modal
                    open={deleteModalOpen}
                    onClose={handleCloseDeleteModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{ ...styled, width: '500px' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="baseline" >
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Confirm Delete
                            </Typography>
                            <CloseIcon onClick={handleCloseDeleteModal} style={{ cursor: 'pointer' }} />
                        </Box>
                        <Divider style={{ borderColor: '#adadad' }} />
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Are you sure you want to delete "{documentToDelete?.doc_name}"?
                        </Typography>
                        <Box mt={4} display="flex" justifyContent="end" >
                            <Button variant="outlined" className='border-primary text-primary rounded-3' onClick={handleCloseDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="contained" className='bg-primary mx-2 rounded-3' onClick={handleDeleteDocument}>
                                Delete
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                {/* Confirmation Modal for File Upload */}
                <Modal
                    open={confirmUploadModalOpen}
                    onClose={handleCancelConfirmUpload}
                    aria-labelledby="confirm-upload-modal-title"
                    aria-describedby="confirm-upload-modal-description"
                >
                    <Box sx={{ ...styled, width: pendingUploadType === 'folder' ? '600px' : '500px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="baseline">
                            <Typography id="confirm-upload-modal-title" variant="h6" component="h2">
                                Confirm Upload
                            </Typography>
                            <IconButton
                                onClick={handleCancelConfirmUpload}
                                sx={{ padding: 0 }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Divider style={{ borderColor: '#adadad' }} />
                        <Typography id="confirm-upload-modal-description" sx={{ mt: 2, fontSize: '16px', mb: pendingUploadType === 'folder' ? 2 : 0 }}>
                            {(() => {
                                // Extract just the folder name (last part of path) instead of full path
                                const getFolderName = (path) => {
                                    if (!path || path.trim() === '') return 'Root';
                                    const parts = path.split('/').filter(p => p.trim() !== '');
                                    return parts.length > 0 ? parts[parts.length - 1] : 'Root';
                                };
                                const targetFolderName = getFolderName(pendingUploadFolderName);
                                
                                return pendingUploadType === 'folder' ? (
                                    <>
                                        Are you sure you want to upload folder <strong>"{pendingUploadFiles.length > 0 ? (pendingUploadFiles[0].webkitRelativePath ? pendingUploadFiles[0].webkitRelativePath.split('/')[0] : 'Uploaded_Folder') : 'folder'}"</strong> ({pendingUploadFiles.length} file{pendingUploadFiles.length !== 1 ? 's' : ''}) in <strong>"{targetFolderName}"</strong>?
                                    </>
                                ) : (
                                    <>
                                        Are you sure you want to upload <strong>"{pendingUploadFile?.name}"</strong> in <strong>"{targetFolderName}"</strong>?
                                    </>
                                );
                            })()}
                        </Typography>
                        
                        {/* Show folder structure for folder uploads */}
                        {pendingUploadType === 'folder' && pendingUploadFiles.length > 0 && (
                            <Box sx={{ 
                                mt: 2,
                                mb: 2,
                                maxHeight: '300px',
                                overflowY: 'auto',
                                border: '1px solid #e0e0e0',
                                borderRadius: '4px',
                                padding: '16px',
                                backgroundColor: '#fafafa',
                                fontFamily: 'Arial, sans-serif',
                                textAlign: 'left'
                            }}>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, fontSize: '12px' }}>
                                    Folder Structure:
                                </Typography>
                                {(() => {
                                    // Group files by folder structure
                                    const folderStructure = {};
                                    pendingUploadFiles.forEach((file, index) => {
                                        const pathParts = file.webkitRelativePath ? file.webkitRelativePath.split('/') : [file.name];
                                        let current = folderStructure;
                                        
                                        for (let i = 0; i < pathParts.length - 1; i++) {
                                            const folderName = pathParts[i];
                                            if (!current[folderName]) {
                                                current[folderName] = { type: 'folder', children: {}, files: [] };
                                            }
                                            current = current[folderName].children;
                                        }
                                        
                                        const fileName = pathParts[pathParts.length - 1];
                                        current[fileName] = { type: 'file', file, index };
                                    });

                                    const renderTree = (structure, level = 0, parentPath = '') => {
                                        const items = [];
                                        
                                        Object.entries(structure).forEach(([name, item], idx, arr) => {
                                            const isLast = idx === arr.length - 1;
                                            const indent = '│  '.repeat(level);
                                            const connector = isLast ? '└── ' : '├── ';
                                            const fullPath = parentPath ? `${parentPath}/${name}` : name;
                                            
                                            if (item.type === 'folder') {
                                                // Folder
                                                items.push(
                                                    <Box key={`folder-${name}`} sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        mb: 0.5,
                                                        fontFamily: 'Arial, sans-serif',
                                                        fontSize: '12px',
                                                        overflow: 'hidden'
                                                    }}>
                                                        <Typography sx={{ 
                                                            color: '#2196f3',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            flex: 1,
                                                            minWidth: 0,
                                                            textAlign: 'left'
                                                        }}
                                                        title={`${indent}${connector}📁 ${name}`}
                                                        >
                                                            {indent}{connector}📁 {name}
                                                        </Typography>
                                                    </Box>
                                                );
                                                
                                                // Render folder contents
                                                items.push(...renderTree(item.children, level + 1, fullPath));
                                            } else {
                                                // File
                                                const fileSize = (item.file.size / (1024 * 1024)).toFixed(2);
                                                items.push(
                                                    <Box 
                                                        key={`file-${name}`} 
                                                        sx={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center',
                                                            mb: 0.5,
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontSize: '12px',
                                                            overflow: 'hidden'
                                                        }}
                                                    >
                                                        <Typography sx={{ 
                                                            color: '#333',
                                                            fontFamily: 'Arial, sans-serif',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            flex: 1,
                                                            minWidth: 0,
                                                            textAlign: 'left'
                                                        }}
                                                        title={`${indent}${connector}📄 ${name} (${fileSize} MB)`}
                                                        >
                                                            {indent}{connector}📄 {name} ({fileSize} MB)
                                                        </Typography>
                                                    </Box>
                                                );
                                            }
                                        });
                                        
                                        return items;
                                    };

                                    return renderTree(folderStructure);
                                })()}
                            </Box>
                        )}
                        
                        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                            <Button 
                                variant="outlined" 
                                className='border-primary text-primary rounded-3' 
                                onClick={handleCancelConfirmUpload}
                                disabled={addDocLoading}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                className='bg-primary rounded-3' 
                                onClick={handleConfirmUpload}
                                disabled={addDocLoading}
                            >
                                {addDocLoading ? 'Uploading...' : 'Submit'}
                            </Button>
                        </Box>
                    </Box>
                </Modal>
            </div>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={fetchLoading}
            >
                <CircularProgress className=' text-primary' />
            </Backdrop>
        </Container>
    );
}
export default RfpPreview;